// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7i8km":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentCardView", ()=>ComponentCardView);
var _jsxRuntime = require("react/jsx-runtime");
var _componentCard = require("./ComponentCard");
var _card = require("../../../@react-spectrum/s2/src/Card");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function ComponentCardView({ items, ariaLabel = 'Items', size = 'S', currentUrl, onAction, renderEmptyState }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.InternalCardViewContext).Provider, {
        value: {
            ElementType: (0, _reactAriaComponents.ListBoxItem),
            layout: 'grid'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
            "aria-label": ariaLabel,
            layout: "grid",
            onAction: onAction,
            ref: (0, _react.useCallback)((el)=>{
                if (el && currentUrl) // Wait for extra collection render.
                requestAnimationFrame(()=>{
                    let link = el.querySelector(`[href="${CSS.escape(currentUrl)}"]`);
                    if (link) el.scrollTo({
                        top: link.offsetTop - 8
                    });
                });
            }, [
                currentUrl
            ]),
            className: function anonymous(props) {
                let rules = " ";
                if (props.isEmpty) rules += ' sd12';
                else rules += ' se12';
                rules += ' DMWMg5d12';
                rules += ' DoezI48b12';
                rules += ' __ytyCQZ12';
                rules += ' Ul12';
                rules += ' ql12';
                rules += ' Te12';
                rules += ' Tof12';
                rules += ' Qe12';
                rules += ' Qof12';
                rules += ' Se12';
                rules += ' Sof12';
                rules += ' Re12';
                rules += ' Rof12';
                rules += ' _Uc12';
                rules += ' __Nc12';
                rules += ' _Tc12';
                rules += ' __Oc12';
                rules += ' Id12';
                rules += ' Ioy12';
                rules += ' Hd12';
                rules += ' Hoy12';
                if (props.isEmpty) rules += ' eb12';
                if (props.isEmpty) rules += ' _Ca12';
                else rules += ' _Ce12';
                rules += ' _Na12';
                rules += ' Pa12';
                rules += ' _ub12';
                rules += ' _Pc12';
                return rules;
            },
            renderEmptyState: renderEmptyState,
            items: items,
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componentCard.ComponentCard), {
                    id: item.id,
                    name: item.name.trim(),
                    href: item.href,
                    description: item.description,
                    size: size
                })
        })
    });
}

},{"0":"54QRr","react/jsx-runtime":"2Is6Z","./ComponentCard":"3VXRx","../../../@react-spectrum/s2/src/Card":"jxfoI","react-aria-components":"dNdIK","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3VXRx":[function(require,module,exports,__globalThis) {
/* eslint-disable rulesdir/imports */ /* eslint-disable monorepo/no-internal-import */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentCard", ()=>ComponentCard);
parcelHelpers.export(exports, "ComponentList", ()=>ComponentList);
var _jsxRuntime = require("react/jsx-runtime");
var _actionBarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ActionBar.svg");
var _actionBarSvgDefault = parcelHelpers.interopDefault(_actionBarSvg);
var _actionButtonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg");
var _actionButtonSvgDefault = parcelHelpers.interopDefault(_actionButtonSvg);
var _actionGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg");
var _actionGroupSvgDefault = parcelHelpers.interopDefault(_actionGroupSvg);
var _adobeDefaultSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/AdobeDefault.svg");
var _adobeDefaultSvgDefault = parcelHelpers.interopDefault(_adobeDefaultSvg);
var _autocompleteSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Autocomplete.svg");
var _autocompleteSvgDefault = parcelHelpers.interopDefault(_autocompleteSvg);
var _avatarGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/AvatarGroup.svg");
var _avatarGroupSvgDefault = parcelHelpers.interopDefault(_avatarGroupSvg);
var _avatarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Avatar.svg");
var _avatarSvgDefault = parcelHelpers.interopDefault(_avatarSvg);
var _badgeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg");
var _badgeSvgDefault = parcelHelpers.interopDefault(_badgeSvg);
var _breadcrumbsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg");
var _breadcrumbsSvgDefault = parcelHelpers.interopDefault(_breadcrumbsSvg);
var _buttonGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg");
var _buttonGroupSvgDefault = parcelHelpers.interopDefault(_buttonGroupSvg);
var _buttonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Button.svg");
var _buttonSvgDefault = parcelHelpers.interopDefault(_buttonSvg);
var _calendarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _s2 = require("@react-spectrum/s2");
var _cardSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Card.svg");
var _cardSvgDefault = parcelHelpers.interopDefault(_cardSvg);
var _cardViewSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/CardView.svg");
var _cardViewSvgDefault = parcelHelpers.interopDefault(_cardViewSvg);
var _checkboxGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg");
var _checkboxGroupSvgDefault = parcelHelpers.interopDefault(_checkboxGroupSvg);
var _checkboxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg");
var _checkboxSvgDefault = parcelHelpers.interopDefault(_checkboxSvg);
var _collectionsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg");
var _collectionsSvgDefault = parcelHelpers.interopDefault(_collectionsSvg);
var _colorAreaSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg");
var _colorAreaSvgDefault = parcelHelpers.interopDefault(_colorAreaSvg);
var _colorFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg");
var _colorFieldSvgDefault = parcelHelpers.interopDefault(_colorFieldSvg);
var _colorPickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg");
var _colorPickerSvgDefault = parcelHelpers.interopDefault(_colorPickerSvg);
var _colorSliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg");
var _colorSliderSvgDefault = parcelHelpers.interopDefault(_colorSliderSvg);
var _colorSwatchPickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg");
var _colorSwatchPickerSvgDefault = parcelHelpers.interopDefault(_colorSwatchPickerSvg);
var _colorSwatchSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg");
var _colorSwatchSvgDefault = parcelHelpers.interopDefault(_colorSwatchSvg);
var _colorWheelSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg");
var _colorWheelSvgDefault = parcelHelpers.interopDefault(_colorWheelSvg);
var _comboBoxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg");
var _comboBoxSvgDefault = parcelHelpers.interopDefault(_comboBoxSvg);
var _contextualHelpSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg");
var _contextualHelpSvgDefault = parcelHelpers.interopDefault(_contextualHelpSvg);
var _dateFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg");
var _dateFieldSvgDefault = parcelHelpers.interopDefault(_dateFieldSvg);
var _datePickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg");
var _datePickerSvgDefault = parcelHelpers.interopDefault(_datePickerSvg);
var _dateRangePickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg");
var _dateRangePickerSvgDefault = parcelHelpers.interopDefault(_dateRangePickerSvg);
var _dialogSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg");
var _dialogSvgDefault = parcelHelpers.interopDefault(_dialogSvg);
var _disclosureGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg");
var _disclosureGroupSvgDefault = parcelHelpers.interopDefault(_disclosureGroupSvg);
var _disclosureSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg");
var _disclosureSvgDefault = parcelHelpers.interopDefault(_disclosureSvg);
var _dividerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Divider.svg");
var _dividerSvgDefault = parcelHelpers.interopDefault(_dividerSvg);
var _dragAndDropSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg");
var _dragAndDropSvgDefault = parcelHelpers.interopDefault(_dragAndDropSvg);
var _dropZoneSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg");
var _dropZoneSvgDefault = parcelHelpers.interopDefault(_dropZoneSvg);
var _exampleList = require("./ExampleList");
var _fileTriggerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg");
var _fileTriggerSvgDefault = parcelHelpers.interopDefault(_fileTriggerSvg);
var _focusScopeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg");
var _focusScopeSvgDefault = parcelHelpers.interopDefault(_focusScopeSvg);
var _formSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Form.svg");
var _formSvgDefault = parcelHelpers.interopDefault(_formSvg);
var _groupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Group.svg");
var _groupSvgDefault = parcelHelpers.interopDefault(_groupSvg);
var _iconsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
var _illustratedMessageSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/IllustratedMessage.svg");
var _illustratedMessageSvgDefault = parcelHelpers.interopDefault(_illustratedMessageSvg);
var _illustrationsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Illustrations.svg");
var _illustrationsSvgDefault = parcelHelpers.interopDefault(_illustrationsSvg);
var _imageSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Image.svg");
var _imageSvgDefault = parcelHelpers.interopDefault(_imageSvg);
var _inlineAlertSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/InlineAlert.svg");
var _inlineAlertSvgDefault = parcelHelpers.interopDefault(_inlineAlertSvg);
var _inputSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Input.svg");
var _inputSvgDefault = parcelHelpers.interopDefault(_inputSvg);
var _internationalizedDateSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg");
var _internationalizedDateSvgDefault = parcelHelpers.interopDefault(_internationalizedDateSvg);
var _internationalizedDefaultSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDefault.svg");
var _internationalizedDefaultSvgDefault = parcelHelpers.interopDefault(_internationalizedDefaultSvg);
var _labeledValueSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg");
var _labeledValueSvgDefault = parcelHelpers.interopDefault(_labeledValueSvg);
var _labelSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Label.svg");
var _labelSvgDefault = parcelHelpers.interopDefault(_labelSvg);
var _linkSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Link.svg");
var _linkSvgDefault = parcelHelpers.interopDefault(_linkSvg);
var _listBoxSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg");
var _listBoxSvgDefault = parcelHelpers.interopDefault(_listBoxSvg);
var _listViewSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg");
var _listViewSvgDefault = parcelHelpers.interopDefault(_listViewSvg);
var _mcpSvg = require("./icons/mcp.svg");
var _mcpSvgDefault = parcelHelpers.interopDefault(_mcpSvg);
var _menuSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg");
var _menuSvgDefault = parcelHelpers.interopDefault(_menuSvg);
var _meterSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg");
var _meterSvgDefault = parcelHelpers.interopDefault(_meterSvg);
var _modalSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Modal.svg");
var _modalSvgDefault = parcelHelpers.interopDefault(_modalSvg);
var _numberFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg");
var _numberFieldSvgDefault = parcelHelpers.interopDefault(_numberFieldSvg);
var _pickerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg");
var _pickerSvgDefault = parcelHelpers.interopDefault(_pickerSvg);
var _popoverSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg");
var _popoverSvgDefault = parcelHelpers.interopDefault(_popoverSvg);
var _progressBarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg");
var _progressBarSvgDefault = parcelHelpers.interopDefault(_progressBarSvg);
var _progressCircleSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg");
var _progressCircleSvgDefault = parcelHelpers.interopDefault(_progressCircleSvg);
var _radioGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg");
var _radioGroupSvgDefault = parcelHelpers.interopDefault(_radioGroupSvg);
var _rangeCalendarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg");
var _rangeCalendarSvgDefault = parcelHelpers.interopDefault(_rangeCalendarSvg);
var _rangeSliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg");
var _rangeSliderSvgDefault = parcelHelpers.interopDefault(_rangeSliderSvg);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaDefaultSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ReactAriaDefault.svg");
var _reactAriaDefaultSvgDefault = parcelHelpers.interopDefault(_reactAriaDefaultSvg);
var _searchFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg");
var _searchFieldSvgDefault = parcelHelpers.interopDefault(_searchFieldSvg);
var _segmentedControlSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/SegmentedControl.svg");
var _segmentedControlSvgDefault = parcelHelpers.interopDefault(_segmentedControlSvg);
var _selectBoxGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/SelectBoxGroup.svg");
var _selectBoxGroupSvgDefault = parcelHelpers.interopDefault(_selectBoxGroupSvg);
var _selectionSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg");
var _selectionSvgDefault = parcelHelpers.interopDefault(_selectionSvg);
var _skeletonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Skeleton.svg");
var _skeletonSvgDefault = parcelHelpers.interopDefault(_skeletonSvg);
var _sliderSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg");
var _sliderSvgDefault = parcelHelpers.interopDefault(_sliderSvg);
var _statusLightSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg");
var _statusLightSvgDefault = parcelHelpers.interopDefault(_statusLightSvg);
var _switchSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg");
var _switchSvgDefault = parcelHelpers.interopDefault(_switchSvg);
var _tableSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Table.svg");
var _tableSvgDefault = parcelHelpers.interopDefault(_tableSvg);
var _tabsSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg");
var _tabsSvgDefault = parcelHelpers.interopDefault(_tabsSvg);
var _tagGroupSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg");
var _tagGroupSvgDefault = parcelHelpers.interopDefault(_tagGroupSvg);
var _textAreaSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg");
var _textAreaSvgDefault = parcelHelpers.interopDefault(_textAreaSvg);
var _textFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg");
var _textFieldSvgDefault = parcelHelpers.interopDefault(_textFieldSvg);
var _timeFieldSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg");
var _timeFieldSvgDefault = parcelHelpers.interopDefault(_timeFieldSvg);
var _toastSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg");
var _toastSvgDefault = parcelHelpers.interopDefault(_toastSvg);
var _toggleButtonSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg");
var _toggleButtonSvgDefault = parcelHelpers.interopDefault(_toggleButtonSvg);
var _toolbarSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Toolbar.svg");
var _toolbarSvgDefault = parcelHelpers.interopDefault(_toolbarSvg);
var _tooltipSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg");
var _tooltipSvgDefault = parcelHelpers.interopDefault(_tooltipSvg);
var _treeSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg");
var _treeSvgDefault = parcelHelpers.interopDefault(_treeSvg);
var _useFocusRingSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg");
var _useFocusRingSvgDefault = parcelHelpers.interopDefault(_useFocusRingSvg);
var _useFocusSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg");
var _useFocusSvgDefault = parcelHelpers.interopDefault(_useFocusSvg);
var _useFocusWithinSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg");
var _useFocusWithinSvgDefault = parcelHelpers.interopDefault(_useFocusWithinSvg);
var _useHoverSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg");
var _useHoverSvgDefault = parcelHelpers.interopDefault(_useHoverSvg);
var _useKeyboardSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg");
var _useKeyboardSvgDefault = parcelHelpers.interopDefault(_useKeyboardSvg);
var _useLongPressSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg");
var _useLongPressSvgDefault = parcelHelpers.interopDefault(_useLongPressSvg);
var _useMoveSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg");
var _useMoveSvgDefault = parcelHelpers.interopDefault(_useMoveSvg);
var _usePressSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg");
var _usePressSvgDefault = parcelHelpers.interopDefault(_usePressSvg);
var _virtualizerSvg = require("@react-spectrum/docs/pages/assets/component-illustrations/Virtualizer.svg");
var _virtualizerSvgDefault = parcelHelpers.interopDefault(_virtualizerSvg);
const componentIllustrations = {
    'Accordion': (0, _disclosureGroupSvgDefault.default),
    'ActionBar': (0, _actionBarSvgDefault.default),
    'ActionButton': (0, _actionButtonSvgDefault.default),
    'ActionButtonGroup': (0, _buttonGroupSvgDefault.default),
    'ActionGroup': (0, _actionGroupSvgDefault.default),
    'ActionMenu': (0, _menuSvgDefault.default),
    'Autocomplete': (0, _autocompleteSvgDefault.default),
    'Avatar': (0, _avatarSvgDefault.default),
    'AvatarGroup': (0, _avatarGroupSvgDefault.default),
    'Badge': (0, _badgeSvgDefault.default),
    'Breadcrumbs': (0, _breadcrumbsSvgDefault.default),
    'Button': (0, _buttonSvgDefault.default),
    'ButtonGroup': (0, _buttonGroupSvgDefault.default),
    'Calendar': (0, _calendarSvgDefault.default),
    'Card': (0, _cardSvgDefault.default),
    'CardView': (0, _cardViewSvgDefault.default),
    'Checkbox': (0, _checkboxSvgDefault.default),
    'CheckboxGroup': (0, _checkboxGroupSvgDefault.default),
    'Collections': (0, _collectionsSvgDefault.default),
    'ColorArea': (0, _colorAreaSvgDefault.default),
    'ColorField': (0, _colorFieldSvgDefault.default),
    'ColorPicker': (0, _colorPickerSvgDefault.default),
    'ColorSlider': (0, _colorSliderSvgDefault.default),
    'ColorSwatch': (0, _colorSwatchSvgDefault.default),
    'ColorSwatchPicker': (0, _colorSwatchPickerSvgDefault.default),
    'ColorWheel': (0, _colorWheelSvgDefault.default),
    'ComboBox': (0, _comboBoxSvgDefault.default),
    'ContextualHelp': (0, _contextualHelpSvgDefault.default),
    'DateField': (0, _dateFieldSvgDefault.default),
    'DatePicker': (0, _datePickerSvgDefault.default),
    'DateRangePicker': (0, _dateRangePickerSvgDefault.default),
    'Dialog': (0, _dialogSvgDefault.default),
    'Disclosure': (0, _disclosureSvgDefault.default),
    'DisclosureGroup': (0, _disclosureGroupSvgDefault.default),
    'Divider': (0, _dividerSvgDefault.default),
    'Drag and Drop': (0, _dragAndDropSvgDefault.default),
    'DropZone': (0, _dropZoneSvgDefault.default),
    'FileTrigger': (0, _fileTriggerSvgDefault.default),
    'FocusScope': (0, _focusScopeSvgDefault.default),
    'Form': (0, _formSvgDefault.default),
    'Forms': (0, _formSvgDefault.default),
    'GridList': (0, _listViewSvgDefault.default),
    'Group': (0, _groupSvgDefault.default),
    'Icons': (0, _iconsSvgDefault.default),
    'IllustratedMessage': (0, _illustratedMessageSvgDefault.default),
    'Illustrations': (0, _illustrationsSvgDefault.default),
    'Image': (0, _imageSvgDefault.default),
    'InlineAlert': (0, _inlineAlertSvgDefault.default),
    'Input': (0, _inputSvgDefault.default),
    'InternationalizedDate': (0, _internationalizedDateSvgDefault.default),
    'Label': (0, _labelSvgDefault.default),
    'LabeledValue': (0, _labeledValueSvgDefault.default),
    'Link': (0, _linkSvgDefault.default),
    'LinkButton': (0, _buttonSvgDefault.default),
    'ListBox': (0, _listBoxSvgDefault.default),
    'ListView': (0, _listViewSvgDefault.default),
    'Menu': (0, _menuSvgDefault.default),
    'Meter': (0, _meterSvgDefault.default),
    'Modal': (0, _modalSvgDefault.default),
    'NumberField': (0, _numberFieldSvgDefault.default),
    'Picker': (0, _pickerSvgDefault.default),
    'Popover': (0, _popoverSvgDefault.default),
    'ProgressBar': (0, _progressBarSvgDefault.default),
    'ProgressCircle': (0, _progressCircleSvgDefault.default),
    'RadioGroup': (0, _radioGroupSvgDefault.default),
    'RangeCalendar': (0, _rangeCalendarSvgDefault.default),
    'RangeSlider': (0, _rangeSliderSvgDefault.default),
    'SearchField': (0, _searchFieldSvgDefault.default),
    'SegmentedControl': (0, _segmentedControlSvgDefault.default),
    'Select': (0, _pickerSvgDefault.default),
    'SelectBoxGroup': (0, _selectBoxGroupSvgDefault.default),
    'Selection': (0, _selectionSvgDefault.default),
    'Skeleton': (0, _skeletonSvgDefault.default),
    'Slider': (0, _sliderSvgDefault.default),
    'StatusLight': (0, _statusLightSvgDefault.default),
    'Switch': (0, _switchSvgDefault.default),
    'Table': (0, _tableSvgDefault.default),
    'TableView': (0, _tableSvgDefault.default),
    'Tabs': (0, _tabsSvgDefault.default),
    'TagGroup': (0, _tagGroupSvgDefault.default),
    'TextArea': (0, _textAreaSvgDefault.default),
    'TextField': (0, _textFieldSvgDefault.default),
    'TimeField': (0, _timeFieldSvgDefault.default),
    'Toast': (0, _toastSvgDefault.default),
    'ToggleButton': (0, _toggleButtonSvgDefault.default),
    'ToggleButtonGroup': (0, _actionGroupSvgDefault.default),
    'Toolbar': (0, _toolbarSvgDefault.default),
    'Tooltip': (0, _tooltipSvgDefault.default),
    'Tree': (0, _treeSvgDefault.default),
    'TreeView': (0, _treeSvgDefault.default),
    'Virtualizer': (0, _virtualizerSvgDefault.default),
    'useFocus': (0, _useFocusSvgDefault.default),
    'useFocusRing': (0, _useFocusRingSvgDefault.default),
    'useFocusWithin': (0, _useFocusWithinSvgDefault.default),
    'useHover': (0, _useHoverSvgDefault.default),
    'useKeyboard': (0, _useKeyboardSvgDefault.default),
    'useLongPress': (0, _useLongPressSvgDefault.default),
    'useMove': (0, _useMoveSvgDefault.default),
    'usePress': (0, _usePressSvgDefault.default),
    'MCP Server': (0, _mcpSvgDefault.default)
};
// Overrides for specific illustrations so they fit within the cards.
const propOverrides = {
    Autocomplete: {
        style: {
            height: 'calc(100% - 16px)'
        }
    },
    DateField: {
        viewBox: '0 -56 276 276'
    },
    TimeField: {
        viewBox: '0 -56 276 276'
    },
    DatePicker: {
        style: {
            alignSelf: 'end',
            height: 'calc(100% - 16px)'
        }
    },
    DateRangePicker: {
        style: {
            alignSelf: 'end',
            height: 'calc(100% - 16px)'
        }
    },
    DropZone: {
        viewBox: '0 0 290 220',
        style: {
            height: 'calc(100% - 16px)'
        }
    },
    Select: {
        // Safari doesn't calculate the max-height correctly with the aspect-ratio.
        style: {
            height: 'calc(100% - 16px)'
        }
    },
    Picker: {
        style: {
            height: 'calc(100% - 16px)'
        }
    },
    ComboBox: {
        style: {
            height: 'calc(100% - 16px)'
        }
    }
};
const illustrationContainer = " Za12 fc12 gWU9V0d12 sd12 eb12 _Ca12 Ma12";
const illustrationStyles = " LbZqs7b12 _4c12 _Ob12";
function getDefaultIllustration(href) {
    if (href.includes('/react-aria/')) return 0, _reactAriaDefaultSvgDefault.default;
    else if (href.includes('/internationalized/')) return 0, _internationalizedDefaultSvgDefault.default;
    return 0, _adobeDefaultSvgDefault.default;
}
function getReleaseVersionLabel(href) {
    let match = href.match(/releases\/(v[\w-]+)\.html$/i);
    if (!match) return null;
    return match[1].replace(/-/g, '.');
}
function ComponentCard({ id, name, href, description, size, ...otherProps }) {
    let IllustrationComponent = componentIllustrations[name] || getDefaultIllustration(href);
    let overrides = propOverrides[name] || {};
    let preview;
    let releaseVersion = getReleaseVersionLabel(href);
    if (releaseVersion) preview = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " Za12 fXaSpn12 gWU9V0d12 sd12 eb12 _Ca12 Ma12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: " uk12 ucJ9TBTb12 ud3Euai12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-h12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 _Fd12 _FnuYUweb12 pYHmX0d12",
            children: releaseVersion
        })
    });
    else if (href.includes('react-aria/examples/') && !href.endsWith('index.html')) preview = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleList.ExampleImage), {
        name: href
    });
    else preview = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: illustrationContainer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IllustrationComponent, {
            ...overrides,
            "aria-hidden": "true",
            // @ts-ignore
            className: illustrationStyles,
            style: {
                maxHeight: 'calc(100% - 16px)',
                ...overrides.style
            }
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
        ...otherProps,
        id: id,
        href: href,
        size: size,
        textValue: name,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                children: preview
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "title",
                        children: name
                    }),
                    description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "description",
                        children: description
                    })
                ]
            })
        ]
    });
}
function ComponentList(props) {
    let pages = props.pages.filter((page)=>props.components.includes(page.name));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: " sd12 Uj12 qj12 _Gc12 _Na12 Pa12 -OJrLde-Se12 -OJrLde-pSm12 SAdf2Be12 RAdf2Be12 Id12 Ipj12 Hd12 Hpj12 Tg12 Qg12 Je12 Ge12 __Rc12 _TAdf2Be12 __OAdf2Be12",
        style: {
            maskImage: 'linear-gradient(to right, transparent, white var(--paddingX) calc(100% - var(--paddingX)), transparent)'
        },
        children: pages.map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComponentCard, {
                    name: getTitle(page),
                    href: page.url,
                    size: "S",
                    UNSAFE_style: {
                        scrollSnapAlign: 'start'
                    }
                })
            }, page.url))
    });
}
const getTitle = (page)=>page.tableOfContents?.[0]?.title ?? '';

},{"0":"9ezzs","1":"bTZ2M","2":"bJSuI","3":"5VeCY","4":"agyF1","react/jsx-runtime":"2Is6Z","@react-spectrum/docs/pages/assets/component-illustrations/ActionBar.svg":"arpdX","@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg":"32Qb1","@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg":"749IL","@react-spectrum/docs/pages/assets/component-illustrations/AdobeDefault.svg":"k8hlh","@react-spectrum/docs/pages/assets/component-illustrations/Autocomplete.svg":"6Zw2k","@react-spectrum/docs/pages/assets/component-illustrations/AvatarGroup.svg":"8G7l3","@react-spectrum/docs/pages/assets/component-illustrations/Avatar.svg":"lIe76","@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg":"d7JsK","@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg":"9ln6U","@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg":"8pq6F","@react-spectrum/docs/pages/assets/component-illustrations/Button.svg":"a6qxN","@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg":"2DS4y","@react-spectrum/s2":[["Card","jxfoI"],["CardPreview","jxfoI"],["Content","10r6w"],["Text","10r6w"]],"@react-spectrum/docs/pages/assets/component-illustrations/Card.svg":"hJbQW","@react-spectrum/docs/pages/assets/component-illustrations/CardView.svg":"iFEI0","@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg":"jrm4a","@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg":"9wByF","@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg":"jj4o5","@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg":"eJLkP","@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg":"12joK","@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg":"1BR1d","@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg":"dfoTB","@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg":"30UMi","@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg":"N8yCP","@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg":"35Nt5","@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg":"kjTat","@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg":"krLkr","@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg":"csR8J","@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg":"8umtV","@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg":"77fJM","@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg":"6xupb","@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg":"8qSw5","@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg":"ZkpS9","@react-spectrum/docs/pages/assets/component-illustrations/Divider.svg":"1p70W","@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg":"8C03J","@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg":"enjcP","./ExampleList":"liGuQ","@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg":"fw3EC","@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg":"ejGAP","@react-spectrum/docs/pages/assets/component-illustrations/Form.svg":"9IhhB","@react-spectrum/docs/pages/assets/component-illustrations/Group.svg":"5tyKX","@react-spectrum/docs/pages/assets/component-illustrations/Icons.svg":"dau7U","@react-spectrum/docs/pages/assets/component-illustrations/IllustratedMessage.svg":"7yMTh","@react-spectrum/docs/pages/assets/component-illustrations/Illustrations.svg":"1GbxI","@react-spectrum/docs/pages/assets/component-illustrations/Image.svg":"2o53d","@react-spectrum/docs/pages/assets/component-illustrations/InlineAlert.svg":"H2J50","@react-spectrum/docs/pages/assets/component-illustrations/Input.svg":"klfEz","@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg":"fOc8v","@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDefault.svg":"kjsQS","@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg":"a9loY","@react-spectrum/docs/pages/assets/component-illustrations/Label.svg":"6zU7Z","@react-spectrum/docs/pages/assets/component-illustrations/Link.svg":"awi79","@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg":"g2KkD","@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg":"8p8fn","./icons/mcp.svg":"bnXl7","@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg":"8ru7h","@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg":"lkbAG","@react-spectrum/docs/pages/assets/component-illustrations/Modal.svg":"b3GHr","@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg":"flFdy","@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg":"5TMfC","@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg":"2P2zw","@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg":"1rojz","@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg":"4067p","@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg":"lj97x","@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg":"kkyyl","@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg":"exnCX","react":"a1TxN","@react-spectrum/docs/pages/assets/component-illustrations/ReactAriaDefault.svg":"ieIqO","@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg":"7ohvF","@react-spectrum/docs/pages/assets/component-illustrations/SegmentedControl.svg":"6r9pK","@react-spectrum/docs/pages/assets/component-illustrations/SelectBoxGroup.svg":"51dMe","@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg":"l7OQE","@react-spectrum/docs/pages/assets/component-illustrations/Skeleton.svg":"32sE8","@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg":"rQclf","@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg":"fFIzk","@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg":"cpk35","@react-spectrum/docs/pages/assets/component-illustrations/Table.svg":"bnlGy","@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg":"blsK2","@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg":"k8kpp","@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg":"aIwiG","@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg":"40HrI","@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg":"bc9cR","@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg":"4qrBC","@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg":"ljWCz","@react-spectrum/docs/pages/assets/component-illustrations/Toolbar.svg":"8vOSr","@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg":"i9JRq","@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg":"2jbL9","@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg":"atBPa","@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg":"bKLu9","@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg":"6rzJ2","@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg":"fdavU","@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg":"d2wmU","@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg":"6sD3B","@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg":"6ZHMO","@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg":"9O6bO","@react-spectrum/docs/pages/assets/component-illustrations/Virtualizer.svg":"hPZ8f","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9ezzs":[function() {},{}],"bTZ2M":[function() {},{}],"bJSuI":[function() {},{}],"5VeCY":[function() {},{}],"agyF1":[function() {},{}],"arpdX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgActionBar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 240 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 240,
                        height: 48,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 239,
                        height: 47,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 5.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "var(--anatomy-gray-700)",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "m16 20 8 8m0-8-8 8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 13,
                fontWeight: 600,
                transform: "translate(40 28)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "3 selected"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(154 12)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 24,
                        fill: "var(--anatomy-gray-600)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "#fff",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        textAnchor: "middle",
                        transform: "translate(18 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(196 12)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 24,
                        fill: "var(--anatomy-gray-600)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "#fff",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        textAnchor: "middle",
                        transform: "translate(18 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Delete"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgActionBar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"32Qb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgActionButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 70 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 69,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M26.784 11.1 23.9 8.216a.6.6 0 0 0-.433-.176h-.017a.69.69 0 0 0-.464.2L12.542 18.686a.5.5 0 0 0-.126.211l-1.388 4.653c-.057.188.229.426.391.426h.031c.138-.031 3.933-1.172 4.656-1.389a.5.5 0 0 0 .207-.125l10.444-10.448a.7.7 0 0 0 .2-.441.6.6 0 0 0-.173-.473M15.7 21.658c-1.081.325-2.431.733-3.365 1.011l1-3.365Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(36 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Edit"
                })
            })
        ]
    });
exports.default = SvgActionButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"749IL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgActionGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 94 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M4 0h28v32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M4 0h28v32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h28a1 1 0 0 0-1 1V0a1 1 0 0 0 1 1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 13)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(9 17)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M31 0h32v32H31Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-400)",
                        d: "M31 0h32v32H31Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h32a1 1 0 0 0-1 1V0a1 1 0 0 0 1 1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 10,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(42 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 16,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(39 17)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 16,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(39 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 10,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(42 13)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M62 0h28a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H62Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-400)",
                        d: "M62 0h28a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H62Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h28a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(73 21)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(70 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(73 13)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 15,
                                height: 2,
                                rx: 0.5,
                                transform: "translate(70 17)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgActionGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8hlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAdobeDefault = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 120 120",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 50,
            height: 44.4,
            transform: "translate(35 38)",
            viewBox: "0 0 501.71 444.05",
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05z"
            })
        })
    });
exports.default = SvgAdobeDefault;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Zw2k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAutocomplete = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 176 205",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Autocomplete_svg__a",
                    width: 176,
                    height: 148,
                    x: 0,
                    y: 57,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(0 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Favorite animal"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(0 24)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 176,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 175,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(12 44)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Ca"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "var(--anatomy-gray-900)",
                        d: "M28 31v14"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Autocomplete_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(0 62)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 176,
                            height: 136,
                            stroke: "none",
                            rx: 4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 175,
                            height: 135,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 3.5
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-900)",
                stroke: "rgba(0,0,0,0)",
                opacity: 0.04,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "none",
                        d: "M2 130h172v32H2z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M2.5 130.5h171v31H2.5z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 86)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Camel"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 118)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Capybara"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 150)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Caribou"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 182)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Cat"
                })
            })
        ]
    });
exports.default = SvgAutocomplete;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8G7l3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAvatarGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 84 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#AvatarGroup_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 52,
                    fill: "var(--anatomy-gray-500)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(68 21)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "IN"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#AvatarGroup_svg__b)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 26,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(42 21)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "RA"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#AvatarGroup_svg__c)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(16 21)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "RS"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "AvatarGroup_svg__c",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h32v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "AvatarGroup_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M26 0h32v32H26z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "AvatarGroup_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M52 0h32v32H52z"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgAvatarGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lIe76":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAvatar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#Avatar_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(16 21)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "RS"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "Avatar_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h32v32H0z"
                    })
                })
            })
        ]
    });
exports.default = SvgAvatar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d7JsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBadge = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 30,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 30px)/2) 10px"
        },
        viewBox: "0 0 82 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 82,
                height: 30,
                fill: "var(--anatomy-gray-700)",
                rx: 5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-50)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                transform: "translate(11 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Approved"
                })
            })
        ]
    });
exports.default = SvgBadge;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9ln6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBreadcrumbs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 20,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 20px)/2) 10px"
        },
        viewBox: "0 0 173 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M53.466 11.108a.8.8 0 0 1-.234.563l-3.192 3.19a.8.8 0 1 1-1.148-1.108l.02-.02 2.627-2.625-2.627-2.627a.8.8 0 0 1 1.108-1.147l.02.02 3.191 3.19a.8.8 0 0 1 .234.564Z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-600)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Home"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-600)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(62 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Assets"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                fontWeight: 700,
                transform: "translate(125 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Photos"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M116.466 11.108a.8.8 0 0 1-.234.563l-3.192 3.19a.8.8 0 1 1-1.148-1.108l.02-.02 2.627-2.625-2.627-2.627a.8.8 0 0 1 1.108-1.147l.02.02 3.191 3.19a.8.8 0 0 1 .234.564Z"
                    })
                })
            })
        ]
    });
exports.default = SvgBreadcrumbs;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8pq6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgButtonGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 162 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(0,0,0,0)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(17 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Cancel"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(88)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 74,
                                height: 32,
                                stroke: "none",
                                rx: 16
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 72,
                                height: 30,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        transform: "translate(104 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Submit"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgButtonGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a6qxN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 72 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-600)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 71,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(22 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Save"
                })
            })
        ]
    });
exports.default = SvgButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2DS4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 153,
            boxSizing: "border-box"
        },
        viewBox: "102 0 300 182",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-236 -34)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 18,
                    fontWeight: 700,
                    transform: "translate(489 52)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -60.426,
                        y: 0,
                        children: "September 2021"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(369 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(411 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.986,
                        y: 0,
                        children: "M"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(449 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(490 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.13,
                        y: 0,
                        children: "W"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(529 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(568 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.048,
                        y: 0,
                        children: "F"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.36,
                        y: 0,
                        children: "5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.045,
                        y: 0,
                        children: "7"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.57,
                        y: 0,
                        children: "8"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.633,
                        y: 0,
                        children: "9"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "10"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.048,
                        y: 0,
                        children: "13"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.174,
                        y: 0,
                        children: "14"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.971,
                        y: 0,
                        children: "15"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "16"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.23,
                        y: 0,
                        children: "19"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.378,
                        y: 0,
                        children: "20"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.013,
                        y: 0,
                        children: "21"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.203,
                        y: 0,
                        children: "22"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.231,
                        y: 0,
                        children: "23"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.147,
                        y: 0,
                        children: "24"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.24,
                        y: 0,
                        children: "1"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.304,
                        y: 0,
                        children: "2"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.388,
                        y: 0,
                        children: "3"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m365.562 46.329 3.535-3.535a1 1 0 0 1 1.415 0 1 1 0 0 1 0 1.414l-2.829 2.828 2.829 2.828a1 1 0 0 1 0 1.415 1 1 0 0 1-1.415 0l-3.535-3.536a1 1 0 0 1-.293-.707 1 1 0 0 1 .293-.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.343,
                        y: 0,
                        children: "26"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.832,
                        y: 0,
                        children: "27"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.329,
                        y: 0,
                        children: "29"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.455,
                        y: 0,
                        children: "30"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.836,
                        y: 0,
                        children: "6"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.252,
                        y: 0,
                        children: "28"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(608 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.9,
                        y: 0,
                        children: "11"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.195,
                        y: 0,
                        children: "18"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.154,
                        y: 0,
                        children: "25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.514,
                        y: 0,
                        children: "4"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m610.243 47.742-3.535 3.535a1 1 0 0 1-1.415 0 1 1 0 0 1 0-1.414l2.829-2.828-2.829-2.828a1 1 0 0 1 0-1.415 1 1 0 0 1 1.415 0l3.535 3.536a1 1 0 0 1 .293.707 1 1 0 0 1-.293.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.985,
                        y: 0,
                        children: "12"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.733,
                        y: 0,
                        children: "17"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(392 144)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.689,
                        y: 0,
                        children: "6"
                    })
                })
            ]
        })
    });
exports.default = SvgCalendar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hJbQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 100,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 140 100",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 140,
                height: 100,
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-300)",
                rx: 6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 120,
                height: 50,
                x: 10,
                y: 10,
                fill: "var(--anatomy-gray-200)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "M61.5 27.5h13A1.5 1.5 0 0 1 76 29v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 60 42V29a1.5 1.5 0 0 1 1.5-1.5M64 34a2.5 2.5 0 1 0-2.5-2.5A2.5 2.5 0 0 0 64 34m11.5 7.5-4-4L69 40l-3-3-5.5 4.5Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 80,
                height: 10,
                x: 10,
                y: 68,
                fill: "var(--anatomy-gray-500)",
                rx: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 110,
                height: 6,
                x: 10,
                y: 82,
                fill: "var(--anatomy-gray-300)",
                rx: 2
            })
        ]
    });
exports.default = SvgCard;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iFEI0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCardView = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 160,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "30px 10px"
        },
        viewBox: "0 0 260 160",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 124,
                height: 76,
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-300)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 112,
                height: 42,
                x: 6,
                y: 6,
                fill: "var(--anatomy-gray-200)",
                rx: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 65,
                height: 7,
                x: 6,
                y: 56,
                fill: "var(--anatomy-gray-500)",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 90,
                height: 5,
                x: 6,
                y: 66,
                fill: "var(--anatomy-gray-300)",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(136)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 124,
                        height: 76,
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-300)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 112,
                        height: 42,
                        x: 6,
                        y: 6,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 65,
                        height: 7,
                        x: 6,
                        y: 56,
                        fill: "var(--anatomy-gray-500)",
                        rx: 1.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 90,
                        height: 5,
                        x: 6,
                        y: 66,
                        fill: "var(--anatomy-gray-300)",
                        rx: 1.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 84)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 124,
                        height: 76,
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-300)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 112,
                        height: 42,
                        x: 6,
                        y: 6,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 65,
                        height: 7,
                        x: 6,
                        y: 56,
                        fill: "var(--anatomy-gray-500)",
                        rx: 1.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 90,
                        height: 5,
                        x: 6,
                        y: 66,
                        fill: "var(--anatomy-gray-300)",
                        rx: 1.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(136 84)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 124,
                        height: 76,
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-300)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 112,
                        height: 42,
                        x: 6,
                        y: 6,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 65,
                        height: 7,
                        x: 6,
                        y: 56,
                        fill: "var(--anatomy-gray-500)",
                        rx: 1.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 90,
                        height: 5,
                        x: 6,
                        y: 66,
                        fill: "var(--anatomy-gray-300)",
                        rx: 1.5
                    })
                ]
            })
        ]
    });
exports.default = SvgCardView;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jrm4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckboxGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 120px)/2) 10px"
        },
        viewBox: "0 0 78 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-75)",
                        d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Travel"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 56)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Music"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 97)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 108)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Shopping"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-700)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    transform: "translate(0 16)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 0,
                        children: "Interests"
                    })
                })
            })
        ]
    });
exports.default = SvgCheckboxGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wByF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 79 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                stroke: "rgba(0,0,0,0)",
                transform: "translate(0 9)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        stroke: "none",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 13,
                        height: 13,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 1.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-75)",
                d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(24 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Subscribe"
                })
            })
        ]
    });
exports.default = SvgCheckbox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jj4o5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCollections = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1347 -1745)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1347 1803)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 17,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1811)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1359 1812)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 11,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1834)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1347 1745)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 17,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1753)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1359 1754)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 167,
                    height: 11,
                    fill: "var(--anatomy-gray-200)",
                    rx: 3,
                    transform: "translate(1399 1776)"
                })
            ]
        })
    });
exports.default = SvgCollections;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eJLkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorArea = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 142,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "5px 0"
        },
        viewBox: "0 0 142 142",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorArea_svg__a",
                    x2: 1,
                    y2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "url(#ColorArea_svg__a)",
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 142,
                        height: 142,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 141,
                        height: 141,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-50)",
                strokeWidth: 2,
                transform: "translate(100 47)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(99 46)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 9,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 8.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 6,
                fill: "var(--anatomy-gray-400)",
                transform: "translate(102 49)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(102 49)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 6,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 5.5
                    })
                ]
            })
        ]
    });
exports.default = SvgColorArea;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"12joK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Background"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "#ABCDEF"
                })
            })
        ]
    });
exports.default = SvgColorField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1BR1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "100%"
        },
        viewBox: "0 0 185.999 160.002",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ColorPicker_svg__c",
                        x2: 0,
                        y1: 1,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0,
                                stopColor: "var(--anatomy-gray-500)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "var(--anatomy-gray-300)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "ColorPicker_svg__b",
                        x1: 1,
                        x2: 0,
                        y1: 1,
                        y2: 0,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0,
                                stopColor: "var(--anatomy-gray-500)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "var(--anatomy-gray-300)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorPicker_svg__d",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "ColorPicker_svg__a",
                        width: 168,
                        height: 160.002,
                        x: 0,
                        y: 0,
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0.149
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#ColorPicker_svg__a)",
                        transform: "translate(-.001 .001)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M150 152.501H10c-1.93 0-3.5-1.57-3.5-3.501V9C6.5 7.07 8.07 5.5 10 5.5h140c1.93 0 3.5 1.57 3.5 3.501v62.208l.147.146 7.646 7.645-7.646 7.647-.147.146V149c0 1.93-1.57 3.501-3.5 3.501"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-400)",
                                    d: "M150 152.001a3.005 3.005 0 0 0 3-3.001V86.585L160.586 79 153 71.415V9A3.005 3.005 0 0 0 150 6H10C8.346 5.999 7 7.346 7 9v140A3.004 3.004 0 0 0 10 152zm0 1H10A4 4 0 0 1 6 149V9A4 4 0 0 1 10 5h140A4 4 0 0 1 154 9v62L162 79l-8 8v62a4 4 0 0 1-4 4.002"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "url(#ColorPicker_svg__b)",
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.1,
                                transform: "translate(13.999 13.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 102,
                                        height: 102,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 101,
                                        height: 101,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(13.999 13.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-50)",
                                        strokeWidth: 2,
                                        transform: "translate(70 32)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 8,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 7
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(69 31)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 9,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 8.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        fill: "var(--anatomy-gray-400)",
                                        transform: "translate(72 34)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(72 34)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 6,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 5.5
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(121.999 13.001)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 102,
                                fill: "var(--anatomy-gray-50)",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "url(#ColorPicker_svg__c)",
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.1,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 24,
                                        height: 102,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 23,
                                        height: 101,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-50)",
                                        strokeWidth: 2,
                                        transform: "translate(4 58)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 8,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 8,
                                                cy: 8,
                                                r: 7
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(3 57)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 9,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 9,
                                                cy: 9,
                                                r: 8.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        fill: "var(--anatomy-gray-400)",
                                        transform: "translate(6 60)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "none",
                                        fillOpacity: 0,
                                        stroke: "var(--anatomy-gray-900)",
                                        strokeOpacity: 0.42,
                                        transform: "translate(6 60)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 6,
                                                stroke: "none"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: 6,
                                                cy: 6,
                                                r: 5.5
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        clipPath: "url(#ColorPicker_svg__d)",
                        transform: "translate(165.999 69.001)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 20,
                                height: 20,
                                fill: "var(--anatomy-gray-400)",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                opacity: 0.51,
                                transform: "translate(.417 .417)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 19.167,
                                    height: 19.167,
                                    fill: "none",
                                    stroke: "var(--anatomy-gray-900)",
                                    rx: 3.5
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(13.999 121.001)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 132,
                                        height: 24,
                                        stroke: "none",
                                        rx: 4
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 131,
                                        height: 23,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 3.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(20.999 137.001)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "#ABCDEF"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgColorPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dfoTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 24,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 24px)/2) 10px"
        },
        viewBox: "0 0 200 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorSlider_svg__a",
                    x2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 200,
                height: 24,
                fill: "var(--anatomy-gray-50)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "url(#ColorSlider_svg__a)",
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.1,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 200,
                        height: 24,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 199,
                        height: 23,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-50)",
                strokeWidth: 2,
                transform: "translate(122 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(121 3)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 9,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 9,
                        cy: 9,
                        r: 8.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 6,
                fill: "var(--anatomy-gray-400)",
                transform: "translate(124 6)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                fillOpacity: 0,
                stroke: "var(--anatomy-gray-900)",
                strokeOpacity: 0.42,
                transform: "translate(124 6)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 6,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 5.5
                    })
                ]
            })
        ]
    });
exports.default = SvgColorSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"30UMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSwatchPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        fill: "none",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2)0",
            width: "100%"
        },
        viewBox: "0 0 236 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__b)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 34.5,
                        y: 0.5,
                        fill: "var(--anatomy-gray-600)",
                        rx: 15.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 34.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-800)",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__c)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 68,
                    fill: "var(--anatomy-gray-500)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__d)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 102,
                        fill: "var(--anatomy-gray-500)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 26,
                        height: 26,
                        x: 105,
                        y: 3,
                        stroke: "var(--anatomy-gray-50)",
                        strokeWidth: 2,
                        rx: 13
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 30,
                        height: 30,
                        x: 103,
                        y: 1,
                        stroke: "var(--anatomy-gray-900)",
                        strokeWidth: 2,
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__e)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 136,
                        fill: "var(--anatomy-gray-400)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 136.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-50)",
                        opacity: 0.2,
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__f)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        x: 170,
                        fill: "var(--anatomy-gray-500)",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 170.5,
                        y: 0.5,
                        stroke: "var(--anatomy-gray-50)",
                        opacity: 0.2,
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#ColorSwatchPicker_svg__g)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    x: 204,
                    fill: "var(--anatomy-gray-600)",
                    rx: 16
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M0 0h32v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M34 0h32v32H34z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__c",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M68 0h32v32H68z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__d",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M102 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__e",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M136 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__f",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M170 0h32v32h-32z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "ColorSwatchPicker_svg__g",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-50)",
                            d: "M204 0h32v32h-32z"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgColorSwatchPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"N8yCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorSwatch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        fill: "none",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2)0",
            width: "100%"
        },
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#ColorSwatch_svg__a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 32,
                        height: 32,
                        fill: "var(--anatomy-gray-500)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 31,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        stroke: "#000",
                        opacity: 0.51,
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "ColorSwatch_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h32v32H0z"
                    })
                })
            })
        ]
    });
exports.default = SvgColorSwatch;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"35Nt5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgColorWheel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)"
        },
        viewBox: "0 0 192.002 192",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "ColorWheel_svg__a",
                    x2: 1,
                    gradientUnits: "objectBoundingBox",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--anatomy-gray-300)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--anatomy-gray-500)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#ColorWheel_svg__a)",
                        d: "M96 192a96.7 96.7 0 0 1-19.347-1.95 95.97 95.97 0 0 1-74.7-74.7 96.9 96.9 0 0 1 0-38.7 95.97 95.97 0 0 1 74.7-74.7 96.9 96.9 0 0 1 38.7 0 95.98 95.98 0 0 1 74.7 74.707 96.9 96.9 0 0 1 0 38.695 95.97 95.97 0 0 1-74.7 74.7A96.7 96.7 0 0 1 96 192m0-168a71.881 71.881 0 1 0 28.022 5.658A71.7 71.7 0 0 0 96 24",
                        transform: "matrix(.95 0 0 .95 4.75 4.75)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "none",
                        fillOpacity: 0,
                        stroke: "var(--anatomy-gray-900)",
                        strokeOpacity: 0.1,
                        transform: "matrix(.95 0 0 .95 4.75 4.75)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 96.001,
                                cy: 96.001,
                                r: 96.001,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 96.001,
                                cy: 96.001,
                                r: 95.501
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "none",
                        fillOpacity: 0,
                        stroke: "var(--anatomy-gray-900)",
                        strokeOpacity: 0.1,
                        transform: "matrix(.95 0 0 .95 26.6 26.599)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 73.001,
                                cy: 73.001,
                                r: 73.001,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 73.001,
                                cy: 73.001,
                                r: 72.501
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "matrix(.95 0 0 .95 4.75 4.75)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-50)",
                                strokeWidth: 2,
                                transform: "translate(147.398 28.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 8,
                                        cy: 8,
                                        r: 8,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 8,
                                        cy: 8,
                                        r: 7
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.42,
                                transform: "translate(146.398 27.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 9,
                                        cy: 9,
                                        r: 9,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 9,
                                        cy: 9,
                                        r: 8.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 6,
                                cy: 6,
                                r: 6,
                                fill: "var(--anatomy-gray-500)",
                                transform: "translate(149.398 30.603)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "none",
                                fillOpacity: 0,
                                stroke: "var(--anatomy-gray-900)",
                                strokeOpacity: 0.42,
                                transform: "translate(149.398 30.603)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 6,
                                        stroke: "none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: 6,
                                        cy: 6,
                                        r: 5.5
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgColorWheel;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kjTat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgComboBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 188 205",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "ComboBox_svg__a",
                    width: 188,
                    height: 148,
                    x: 0,
                    y: 57,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(6 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Favorite animal"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(6 24)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 176,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 175,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-200)",
                        d: "M148 24h30a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-30Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M148 24h30a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-30Zm0 1a1 1 0 0 0 1-1v32a1 1 0 0 0-1-1h30a3 3 0 0 0 3-3V28a3 3 0 0 0-3-3Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 44)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Ca"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M169.99 38.01a1 1 0 0 0-1.707-.71L165 40.586l-3.283-3.286a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(6 24)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 176,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 175,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#ComboBox_svg__a)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(6 62)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 176,
                                    height: 136,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 175,
                                    height: 135,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        stroke: "rgba(0,0,0,0)",
                        opacity: 0.04,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M8 130h172v32H8z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M8.5 130.5h171v31H8.5z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 66h60v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 66.5h59v31h-59z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 86)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Camel"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 98h78v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 98.5h77v31h-77z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 118)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Capybara"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 130h68v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 130.5h67v31h-67z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 150)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Caribou"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(255,0,0,0)",
                        stroke: "rgba(0,0,0,0)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M18 162h42v32H18z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M18.5 162.5h41v31h-41z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 182)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Cat"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                stroke: "var(--anatomy-gray-600)",
                d: "M34.5 31.5v16"
            })
        ]
    });
exports.default = SvgComboBox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"krLkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgContextualHelp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 140,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 140px)/2) 10px"
        },
        viewBox: "0 0 252 140",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "ContextualHelp_svg__a",
                    width: 252,
                    height: 115,
                    x: 0,
                    y: 25,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#ContextualHelp_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M242 132.5H10c-1.93 0-3.5-1.57-3.5-3.5V34c0-1.93 1.57-3.5 3.5-3.5h232c1.93 0 3.5 1.57 3.5 3.5v95c0 1.93-1.57 3.5-3.5 3.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "M10 31c-1.654 0-3 1.346-3 3v95c0 1.654 1.346 3 3 3h232c1.654 0 3-1.346 3-3V34c0-1.654-1.346-3-3-3zm0-1h232a4 4 0 0 1 4 4v95a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V34a4 4 0 0 1 4-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                fontWeight: 700,
                transform: "translate(18 41)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 16,
                    children: "Permission required"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M18.955 9.333a.956.956 0 1 1-.956-.956.956.956 0 0 1 .956.956m.082 5.333h-.149v-3.378a.18.18 0 0 0-.178-.178h-1.748s-.518.014-.518.444.518.444.518.444h.148v2.667h-.148s-.518.014-.518.444.518.444.518.444h2.075s.518-.015.518-.444-.518-.443-.518-.443M18 4.444A7.556 7.556 0 1 0 25.556 12 7.556 7.556 0 0 0 18 4.444m0 13.489A5.933 5.933 0 1 1 23.933 12 5.933 5.933 0 0 1 18 17.933"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 13,
                transform: "translate(18 63)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 13,
                        children: "Your admin must grant you permission "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 31.2,
                        children: "before you can create a segment."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 13,
                textDecoration: "underline",
                transform: "translate(18 120)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Learn about permissions"
                })
            })
        ]
    });
exports.default = SvgContextualHelp;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csR8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDateField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "10px calc((100% - 176px)/2)",
            height: "calc(152px - 20px)",
            width: 176
        },
        viewBox: "8 53 264 52",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-341 -39)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            strokeWidth: 1.5,
                            transform: "translate(349 104)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 264,
                                    height: 48,
                                    stroke: "none",
                                    rx: 6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 262.5,
                                    height: 46.5,
                                    x: 0.75,
                                    y: 0.75,
                                    fill: "none",
                                    rx: 5.25
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Event date"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 23,
                    height: 26,
                    fill: "var(--anatomy-gray-700)",
                    rx: 2,
                    transform: "translate(366 115)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 21,
                    transform: "translate(367 134)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            x: 8,
                            y: 0,
                            children: "8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            y: 0,
                            fill: "var(--anatomy-gray-700)",
                            children: " / 15 / 2022"
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgDateField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8umtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDatePicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            maxHeight: 153,
            background: "var(--anatomy-gray-100)",
            padding: "10px 10px 0",
            boxSizing: "border-box"
        },
        viewBox: "69 40 376 280",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DatePicker_svg__a",
                    width: 441,
                    height: 427,
                    x: 58,
                    y: 114,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(-280 -39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 1.5,
                        transform: "translate(349 104)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 264,
                                height: 48,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 262.5,
                                height: 46.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 18,
                        transform: "translate(349 92)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Event date"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 23,
                        height: 26,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(366 115)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 21,
                        transform: "translate(367 134)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                x: 8,
                                y: 0,
                                children: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                y: 0,
                                fill: "var(--anatomy-gray-800)",
                                children: " / 10 / 2021"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M607 151.25h-44.25v-46.5H607a5.256 5.256 0 0 1 5.25 5.25v36a5.256 5.256 0 0 1-5.25 5.25"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M563.5 105.5v45H607c2.481 0 4.5-2.019 4.5-4.5v-36c0-2.481-2.019-4.5-4.5-4.5zM562 104h45a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6h-45z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 124.707)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 128.198)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(581.798 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(585.289 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(588.78 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                stroke: "var(--anatomy-gray-700)",
                                transform: "translate(592.271 131.69)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 2.328,
                                        height: 2.328,
                                        stroke: "none",
                                        rx: 0.5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "none",
                                        d: "M.5.5h1.328v1.328H.5z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M598.091 119.471h-3.492v-1.746a.58.58 0 0 0-.582-.582h-1.163a.58.58 0 0 0-.582.582v1.746h-8.147v-1.746a.58.58 0 0 0-.581-.582h-1.164a.58.58 0 0 0-.582.582v1.746h-3.491a.58.58 0 0 0-.582.581v17.457a.58.58 0 0 0 .582.582h19.784a.58.58 0 0 0 .582-.582v-17.457a.58.58 0 0 0-.582-.581m-1.166 16.872h-17.454v-15.127h2.327v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .581-.582v-1.164h8.146v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .582-.582v-1.164h2.326Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                filter: "url(#DatePicker_svg__a)",
                                transform: "translate(280 39)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-50)",
                                    stroke: "rgba(0,0,0,0)",
                                    transform: "translate(69 121)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 376,
                                            height: 364,
                                            stroke: "none",
                                            rx: 5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 375,
                                            height: 363,
                                            x: 0.5,
                                            y: 0.5,
                                            fill: "none",
                                            rx: 4.5
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(349 160)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 376,
                                        height: 364,
                                        stroke: "none",
                                        rx: 5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 375,
                                        height: 363,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 4.5
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 20,
                        fontWeight: 700,
                        transform: "translate(538 216)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -67.14,
                            y: 0,
                            children: "September 2021"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(403 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(450 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.402,
                            y: 0,
                            children: "M"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(493 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(539 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.13,
                            y: 0,
                            children: "W"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(583 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(626 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.302,
                            y: 0,
                            children: "F"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.36,
                            y: 0,
                            children: "5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.263,
                            y: 0,
                            children: "7"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.825,
                            y: 0,
                            children: "8"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(581 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.892,
                            y: 0,
                            children: "9"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "10"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.48,
                            y: 0,
                            children: "13"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(492 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.174,
                            y: 0,
                            children: "14"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(536 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.398,
                            y: 0,
                            children: "15"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "16"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 429)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.23,
                            y: 0,
                            children: "19"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(448 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.905,
                            y: 0,
                            children: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.443,
                            y: 0,
                            children: "21"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.717,
                            y: 0,
                            children: "22"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.747,
                            y: 0,
                            children: "23"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(627 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.657,
                            y: 0,
                            children: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -2.4,
                            y: 0,
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.304,
                            y: 0,
                            children: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.388,
                            y: 0,
                            children: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M399.658 210.397a1.11 1.11 0 0 1 .328-.791l3.956-3.956a1.119 1.119 0 0 1 1.582 1.582l-3.165 3.165 3.165 3.165a1.119 1.119 0 0 1-1.582 1.583l-3.956-3.957a1.11 1.11 0 0 1-.328-.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(403 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.867,
                            y: 0,
                            children: "26"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.32,
                            y: 0,
                            children: "27"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.852,
                            y: 0,
                            children: "29"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.987,
                            y: 0,
                            children: "30"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.953,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.77,
                            y: 0,
                            children: "28"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(671 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.25,
                            y: 0,
                            children: "11"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(671 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.195,
                            y: 0,
                            children: "18"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.665,
                            y: 0,
                            children: "25"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.765,
                            y: 0,
                            children: "4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M674.123 210.397a1.11 1.11 0 0 1-.328.791l-3.956 3.956a1.119 1.119 0 0 1-1.582-1.582l3.165-3.165-3.165-3.165a1.119 1.119 0 0 1 1.582-1.583l3.956 3.957a1.11 1.11 0 0 1 .328.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(402 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.412,
                            y: 0,
                            children: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 35,
                        height: 35,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(609 318)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.142,
                            y: 0,
                            children: "10"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgDatePicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"77fJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDateRangePicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            maxHeight: 152,
            background: "var(--anatomy-gray-100)",
            padding: "10px 10px 0",
            boxSizing: "border-box"
        },
        viewBox: "69 40 376 280",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DateRangePicker_svg__a",
                    width: 394,
                    height: 382,
                    x: 60,
                    y: 114,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(-280 -39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                filter: "url(#DateRangePicker_svg__a)",
                                transform: "translate(280 39)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-50)",
                                    stroke: "rgba(0,0,0,0)",
                                    transform: "translate(69 121)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 376,
                                            height: 364,
                                            stroke: "none",
                                            rx: 5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 375,
                                            height: 363,
                                            x: 0.5,
                                            y: 0.5,
                                            fill: "none",
                                            rx: 4.5
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-400)",
                                transform: "translate(349 160)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 376,
                                        height: 364,
                                        stroke: "none",
                                        rx: 5
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 375,
                                        height: 363,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 4.5
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M671.281 273a17.9 17.9 0 1 1-17.9 17.9 17.9 17.9 0 0 1 17.9-17.9"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M403.828 318a17.9 17.9 0 1 1-17.9 17.9 17.9 17.9 0 0 1 17.9-17.9"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M622 273h50v36h-50z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M404 318h132v36H404z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 36,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(609 273)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 36,
                        height: 36,
                        fill: "var(--anatomy-gray-700)",
                        rx: 17.5,
                        transform: "translate(518 318)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 20,
                        fontWeight: 700,
                        transform: "translate(538 216)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -67.14,
                            y: 0,
                            children: "September 2021"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(403 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(450 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.402,
                            y: 0,
                            children: "M"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(493 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(539 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.13,
                            y: 0,
                            children: "W"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(583 258)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.24,
                            y: 0,
                            children: "T"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(626 259)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.302,
                            y: 0,
                            children: "F"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.36,
                            y: 0,
                            children: "5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.263,
                            y: 0,
                            children: "7"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.825,
                            y: 0,
                            children: "8"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(581 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.892,
                            y: 0,
                            children: "9"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 340)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "10"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.48,
                            y: 0,
                            children: "13"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(492 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.174,
                            y: 0,
                            children: "14"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(536 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.398,
                            y: 0,
                            children: "15"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.349,
                            y: 0,
                            children: "16"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(402 429)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.23,
                            y: 0,
                            children: "19"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(448 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.905,
                            y: 0,
                            children: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.443,
                            y: 0,
                            children: "21"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.717,
                            y: 0,
                            children: "22"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.747,
                            y: 0,
                            children: "23"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(627 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.657,
                            y: 0,
                            children: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -2.4,
                            y: 0,
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(581 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.304,
                            y: 0,
                            children: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(626 295)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.388,
                            y: 0,
                            children: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M399.658 210.397a1.11 1.11 0 0 1 .328-.791l3.956-3.956a1.119 1.119 0 0 1 1.582 1.582l-3.165 3.165 3.165 3.165a1.119 1.119 0 0 1-1.582 1.583l-3.956-3.957a1.11 1.11 0 0 1-.328-.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(403 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.867,
                            y: 0,
                            children: "26"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.32,
                            y: 0,
                            children: "27"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(537 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.852,
                            y: 0,
                            children: "29"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(582 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.987,
                            y: 0,
                            children: "30"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -4.11,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(492 475)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.77,
                            y: 0,
                            children: "28"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        letterSpacing: ".06em",
                        transform: "translate(671 260)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.472,
                            y: 0,
                            children: "S"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -5.25,
                            y: 0,
                            children: "11"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        letterSpacing: ".06em",
                        transform: "translate(671 384)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.195,
                            y: 0,
                            children: "18"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 430)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -7.665,
                            y: 0,
                            children: "25"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(671 296)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.765,
                            y: 0,
                            children: "4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M674.123 210.397a1.11 1.11 0 0 1-.328.791l-3.956 3.956a1.119 1.119 0 0 1-1.582-1.582l3.165-3.165-3.165-3.165a1.119 1.119 0 0 1 1.582-1.583l3.956 3.957a1.11 1.11 0 0 1 .328.791"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(402 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.412,
                            y: 0,
                            children: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(626 385)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -6.142,
                            y: 0,
                            children: "17"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        letterSpacing: ".06em",
                        transform: "translate(447 341)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -3.953,
                            y: 0,
                            children: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 1.5,
                        transform: "translate(349 104)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 376,
                                height: 48,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 374.5,
                                height: 46.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Event date"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-200)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M719 151.25h-44.25v-46.5H719a5.256 5.256 0 0 1 5.25 5.25v36a5.256 5.256 0 0 1-5.25 5.25"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-600)",
                                            d: "M675.5 105.5v45H719c2.481 0 4.5-2.019 4.5-4.5v-36c0-2.481-2.019-4.5-4.5-4.5zM674 104h45a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6h-45z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-700)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 124.707)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 128.198)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(693.798 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(697.289 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(700.78 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            stroke: "var(--anatomy-gray-700)",
                                            transform: "translate(704.271 131.69)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 2.328,
                                                    height: 2.328,
                                                    stroke: "none",
                                                    rx: 0.5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "none",
                                                    d: "M.5.5h1.328v1.328H.5z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M710.091 119.471h-3.492v-1.746a.58.58 0 0 0-.582-.582h-1.163a.58.58 0 0 0-.582.582v1.746h-8.147v-1.746a.58.58 0 0 0-.581-.582h-1.164a.58.58 0 0 0-.582.582v1.746h-3.491a.58.58 0 0 0-.582.581v17.457a.58.58 0 0 0 .582.582h19.784a.58.58 0 0 0 .582-.582v-17.457a.58.58 0 0 0-.582-.581m-1.166 16.872h-17.454v-15.127h2.327v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .581-.582v-1.164h8.146v1.164a.58.58 0 0 0 .582.582h1.164a.58.58 0 0 0 .582-.582v-1.164h2.326Z"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-50)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 21,
                            transform: "translate(523 134)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                xmlSpace: "preserve",
                                x: 8,
                                y: 0,
                                fill: "var(--anatomy-gray-800)",
                                children: "9 / 8 / 2021"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 26,
                                fill: "var(--anatomy-gray-700)",
                                rx: 2,
                                transform: "translate(366 115)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                fill: "var(--anatomy-gray-50)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 21,
                                transform: "translate(367 134)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        xmlSpace: "preserve",
                                        x: 8,
                                        y: 0,
                                        children: "9"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        xmlSpace: "preserve",
                                        y: 0,
                                        fill: "var(--anatomy-gray-800)",
                                        children: " /   3 / 2021   \u2013  "
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgDateRangePicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6xupb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDialog = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 229,
        style: {
            background: "var(--anatomy-gray-400)",
            padding: 10,
            boxSizing: "border-box",
            maxHeight: 153
        },
        viewBox: "0 0 480 229",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 480,
                height: 229,
                fill: "var(--anatomy-gray-100)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(40 40)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 18,
                    children: "Delete file"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 400,
                height: 2,
                fill: "var(--anatomy-gray-300)",
                rx: 1,
                transform: "translate(40 74)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(40 92)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 14,
                    children: "Are you sure you want to delete \"budget.xls\"? It cannot be recovered."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "rgba(0,0,0,0)",
                        stroke: "var(--anatomy-gray-300)",
                        strokeWidth: 2,
                        transform: "translate(280 157)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 72,
                                height: 32,
                                stroke: "none",
                                rx: 16
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 70,
                                height: 30,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        transform: "translate(297 177)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "rgba(0,0,0,0)",
                                stroke: "var(--anatomy-gray-800)",
                                strokeWidth: 2,
                                transform: "translate(368 157)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 72,
                                        height: 32,
                                        stroke: "none",
                                        rx: 16
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 70,
                                        height: 30,
                                        x: 1,
                                        y: 1,
                                        fill: "none",
                                        rx: 15
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                fontWeight: 700,
                                transform: "translate(385 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Delete"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M430.563 41.29 422.2 56.255a.5.5 0 0 0 .436.745h16.728a.5.5 0 0 0 .436-.744l-8.364-14.966a.5.5 0 0 0-.872 0ZM432 54.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Z"
            })
        ]
    });
exports.default = SvgDialog;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8qSw5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDisclosureGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 266 163",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-100)",
                d: "M0 0h266v163H0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M48 36h164v1H48z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M48 85h164v1H48zM48 134h164v1H48z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M72 61a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M72 110a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(82 67)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Recent"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(82 116)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Abstract"
                })
            })
        ]
    });
exports.default = SvgDisclosureGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ZkpS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDisclosure = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 266 163",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-100)",
                d: "M0 0h266v163H0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M96.092 84.198a.9.9 0 0 0-.3-.7l-4-4a.967.967 0 0 0-1.4 0 .967.967 0 0 0 0 1.4l3.2 3.3-3.3 3.3a.97.97 0 0 0-.1 1.4.97.97 0 0 0 1.4.1l.1-.1 4-4a1.01 1.01 0 0 0 .4-.7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 18,
                fontWeight: 700,
                transform: "translate(107.015 88.67)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Recent"
                })
            })
        ]
    });
exports.default = SvgDisclosure;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1p70W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDivider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 1,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 180 1",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--anatomy-gray-400)",
            d: "M0 0h180v1H0z"
        })
    });
exports.default = SvgDivider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8C03J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDragAndDrop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 129,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 129px)/2) 3px calc((152px - 129px)/2) 17px"
        },
        viewBox: "0 0 215 129",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "DragAndDrop_svg__a",
                    width: 198,
                    height: 44,
                    x: 17,
                    y: 15,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 71)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Applications"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 76h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 75h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 39)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Pictures"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 44h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 43h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                        fill: "var(--anatomy-gray-800)",
                                        fontFamily: "var(--anatomy-font)",
                                        fontSize: 14,
                                        transform: "translate(39 103)",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                            x: 0,
                                            y: 14,
                                            children: "Downloads"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-700)",
                                            d: "M29.5 108h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H15a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 107h4.965l1.943 2H15Z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        transform: "translate(-2746 -366)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 194,
                                                height: 32,
                                                fill: "var(--anatomy-gray-100)",
                                                stroke: "var(--anatomy-gray-900)",
                                                strokeWidth: 2,
                                                rx: 4,
                                                transform: "translate(2747 367)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "var(--anatomy-gray-600)",
                                                fillOpacity: 0.15,
                                                d: "M2751 367h185.812a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H2751a4 4 0 0 1-4-4v-24a4 4 0 0 1 4-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                fill: "var(--anatomy-gray-800)",
                                                fontFamily: "var(--anatomy-font)",
                                                fontSize: 14,
                                                transform: "translate(2785 373)",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                    x: 0,
                                                    y: 14,
                                                    children: "Shared"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                    fill: "var(--anatomy-gray-700)",
                                                    d: "M2775.5 378h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H2761a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5m-14.5-1h4.965l1.943 2H2761Z"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                            filter: "url(#DragAndDrop_svg__a)",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                fill: "var(--anatomy-gray-100)",
                                                stroke: "var(--anatomy-gray-700)",
                                                transform: "translate(23 20)",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 186,
                                                        height: 32,
                                                        stroke: "none",
                                                        rx: 4
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                        width: 185,
                                                        height: 31,
                                                        x: 0.5,
                                                        y: 0.5,
                                                        fill: "none",
                                                        rx: 3.5
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                            transform: "translate(19 16)",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                    fill: "var(--anatomy-gray-75)",
                                                    stroke: "var(--anatomy-gray-700)",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                            width: 186,
                                                            height: 32,
                                                            stroke: "none",
                                                            rx: 4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                            width: 185,
                                                            height: 31,
                                                            x: 0.5,
                                                            y: 0.5,
                                                            fill: "none",
                                                            rx: 3.5
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                    width: 185.812,
                                                    height: 32,
                                                    fill: "none",
                                                    rx: 4
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                    fill: "var(--anatomy-gray-800)",
                                                    fontFamily: "var(--anatomy-font)",
                                                    fontSize: 14,
                                                    transform: "translate(38 6)",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                        x: 0,
                                                        y: 14,
                                                        children: "Music"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        fill: "var(--anatomy-gray-700)",
                                                        d: "M28.5 11h-7.166l-1.652-1.7a1 1 0 0 0-.717-.3H14a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M14 10h4.965l1.943 2H14Z"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        transform: "translate(179 23)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 18,
                                                height: 18,
                                                fill: "var(--anatomy-gray-800)",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                                fill: "var(--anatomy-gray-50)",
                                                fontFamily: "var(--anatomy-font)",
                                                fontSize: 12,
                                                transform: "translate(2 1)",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                                    x: 4.168,
                                                    y: 12,
                                                    children: "2"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fillRule: "evenodd",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "#fff",
                                        d: "M136 44.422V28.407l11.591 11.619h-6.781l-.411.124Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "#fff",
                                        d: "m145.084 45.1-3.6 1.535-4.684-11.093 3.686-1.553Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "m143.751 44.416-1.844.774-3.1-7.374 1.841-.775Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M137 30.814V42l2.969-2.866.431-.134h4.768Z"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgDragAndDrop;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"enjcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropZone = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "30 0 230 220",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "DropZone_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h271v2H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "DropZone_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h2v195H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__a)",
                transform: "translate(10.001 .001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M0 0h8v2H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M12 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M24 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M36 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M48 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M60 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M72 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M84 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M96 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M108 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M120 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M132 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M144 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M156 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M168 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M180 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M192 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M204 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M216 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M228 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M240 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M252 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M264 0h8v2h-8z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__a)",
                transform: "translate(10.001 212.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h8v2H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M12 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M24 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M36 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M48 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M60 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M72 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M84 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M96 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M108 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M120 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M132 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M144 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M156 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M168 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M180 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M192 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M204 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M216 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M228 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M240 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M252 0h8v2h-8z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M264 0h8v2h-8z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__b)",
                transform: "translate(.001 9.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 12h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 24h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 36h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 48h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 60h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 72h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 84h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 96h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 108h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 120h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 132h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 144h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 156h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 168h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 180h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 192h2v8H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#DropZone_svg__b)",
                transform: "translate(288.001 9.001)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 0h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 12h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 24h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 36h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 48h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 60h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 72h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 84h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 96h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 108h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 120h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 132h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 144h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 156h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 168h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 180h2v8H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-300)",
                            d: "M0 192h2v8H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M2.001 6.001h-2a6.007 6.007 0 0 1 6-6v2a4.006 4.006 0 0 0-4 4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M284.001 2.001v-2a6.007 6.007 0 0 1 6 6h-2a4.006 4.006 0 0 0-4-4M6.001 212.001v2a6.007 6.007 0 0 1-6-6h2a4.006 4.006 0 0 0 4 4M288.001 209.001h2a6.007 6.007 0 0 1-6 6v-2a4.006 4.006 0 0 0 4-4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 22,
                fontWeight: 700,
                transform: "translate(145.001 158.001)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -106.854,
                    y: 0,
                    children: "Drag and drop your file"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-500)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M98.268 74.749H56.726a2.967 2.967 0 0 0-3.029 2.821v28.206a2.967 2.967 0 0 0 3.029 2.821h41.542a2.967 2.967 0 0 0 3.029-2.821V77.57a2.967 2.967 0 0 0-3.029-2.821m-41.542 2.418h41.542a.4.4 0 0 1 .433.4v24.66l-9.953-9.429a2.64 2.64 0 0 0-1.9-.725 2.8 2.8 0 0 0-1.9.725l-4.068 4.029-10.22-9.667a2.64 2.64 0 0 0-1.9-.725 2.8 2.8 0 0 0-1.9.725l-10.563 9.989V77.57a.4.4 0 0 1 .429-.403m-.429 28.609V99.49L68.15 88.368a.97.97 0 0 1 .606-.242.81.81 0 0 1 .606.242l19.126 17.811H56.726a.4.4 0 0 1-.429-.403m41.975.4h-7.447c0-.081-.087-.081-.087-.161l-8.568-8.056 4.068-4.029a.81.81 0 0 1 .606-.242.7.7 0 0 1 .606.242l11.247 10.637v1.209a.4.4 0 0 1-.429.403Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M91.797 88.876a3.95 3.95 0 0 0 2.9-1.239 4.307 4.307 0 0 0-2.9-7.288 4.07 4.07 0 0 0-2.9 1.239 4.32 4.32 0 0 0-1.2 2.988 4.19 4.19 0 0 0 4.1 4.3m-1.911-6.195a2.7 2.7 0 0 1 1.911-.8 2.73 2.73 0 0 1 2.694 2.768 2.86 2.86 0 0 1-.778 1.968 2.7 2.7 0 0 1-1.911.8 2.73 2.73 0 0 1-2.69-2.768 2.86 2.86 0 0 1 .779-1.968Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M232.962 75.532h-23.311l-6.428-5.765a4.06 4.06 0 0 0-2.571-1.018H187.54a2.693 2.693 0 0 0-2.743 2.713v34a3.147 3.147 0 0 0 3.171 3.137h45.166a3.147 3.147 0 0 0 3.171-3.137V78.668a3.355 3.355 0 0 0-3.343-3.136m-45.509-4.239h13.113a1.1 1.1 0 0 1 .857.339l4.371 3.9h-18.512v-4.07a.183.183 0 0 1 .172-.17Zm46.109 34.166a.583.583 0 0 1-.6.593h-45.165a.583.583 0 0 1-.6-.593V78.075h45.68a.583.583 0 0 1 .6.593v26.791Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m149.714 118.776-5 5.312V97.026a1.016 1.016 0 1 0-2.028 0v27.062l-5-5.312a.94.94 0 0 0-1.419 0 1.16 1.16 0 0 0 0 1.507l6.016 6.389a1.9 1.9 0 0 0 1.42.646 1.8 1.8 0 0 0 1.419-.646l6.016-6.389a1.085 1.085 0 0 0 0-1.507.94.94 0 0 0-1.424 0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M168.523 60.205a1.4 1.4 0 0 0-1.2 1.481v43.157a.78.78 0 0 1-.641.79h-15.785a1.514 1.514 0 0 0 0 2.963h15.782c1.682 0 3.044-1.679 3.044-3.753V61.686a1.4 1.4 0 0 0-1.2-1.481"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M169.725 60.823a.66.66 0 0 0-.091-.446c-.091-.178-.183-.267-.274-.446l-19.168-17.825a2 2 0 0 0-.456-.267 1.4 1.4 0 0 0-.548-.09h-28.022a3.427 3.427 0 0 0-3.469 3.387v60.073a3.427 3.427 0 0 0 3.469 3.387h16.156a1.337 1.337 0 1 0 0-2.674h-16.156a.776.776 0 0 1-.73-.713V45.136a.776.776 0 0 1 .73-.713h26.652v14.439a3.427 3.427 0 0 0 3.469 3.387h17.343c.091 0 .183 0 .183-.089h.091c.091 0 .183-.089.274-.089l.091-.089c.091 0 .091-.089.183-.089a2 2 0 0 0 .274-.446v-.624Zm-19.168-1.961V46.205l14.33 13.37h-13.69a.77.77 0 0 1-.64-.713"
                    })
                ]
            })
        ]
    });
exports.default = SvgDropZone;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"liGuQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleList", ()=>ExampleList);
parcelHelpers.export(exports, "ExampleImage", ()=>ExampleImage);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _crudPng = require("url:../pages/react-aria/examples/crud.png");
var _crudPngDefault = parcelHelpers.interopDefault(_crudPng);
var _crudDarkPng = require("url:../pages/react-aria/examples/crud-dark.png");
var _crudDarkPngDefault = parcelHelpers.interopDefault(_crudDarkPng);
var _emojiPickerPng = require("url:../pages/react-aria/examples/emoji-picker.png");
var _emojiPickerPngDefault = parcelHelpers.interopDefault(_emojiPickerPng);
var _emojiPickerDarkPng = require("url:../pages/react-aria/examples/emoji-picker-dark.png");
var _emojiPickerDarkPngDefault = parcelHelpers.interopDefault(_emojiPickerDarkPng);
var _iosListPng = require("url:react-aria-components/docs/examples/ios-list.png");
var _iosListPngDefault = parcelHelpers.interopDefault(_iosListPng);
var _iosListDarkPng = require("url:../pages/react-aria/examples/ios-list-dark.png");
var _iosListDarkPngDefault = parcelHelpers.interopDefault(_iosListDarkPng);
var _kanbanPng = require("url:../pages/react-aria/examples/kanban.png");
var _kanbanPngDefault = parcelHelpers.interopDefault(_kanbanPng);
var _kanbanDarkPng = require("url:../pages/react-aria/examples/kanban-dark.png");
var _kanbanDarkPngDefault = parcelHelpers.interopDefault(_kanbanDarkPng);
var _path = require("path");
var _pathDefault = parcelHelpers.interopDefault(_path);
var _photosPng = require("url:../pages/react-aria/examples/photos.png");
var _photosPngDefault = parcelHelpers.interopDefault(_photosPng);
var _photosDarkPng = require("url:../pages/react-aria/examples/photos-dark.png");
var _photosDarkPngDefault = parcelHelpers.interopDefault(_photosDarkPng);
var _rippleButtonPng = require("url:react-aria-components/docs/examples/ripple-button.png");
var _rippleButtonPngDefault = parcelHelpers.interopDefault(_rippleButtonPng);
var _sheetPng = require("url:../pages/react-aria/examples/sheet.png");
var _sheetPngDefault = parcelHelpers.interopDefault(_sheetPng);
var _sheetDarkPng = require("url:../pages/react-aria/examples/sheet-dark.png");
var _sheetDarkPngDefault = parcelHelpers.interopDefault(_sheetDarkPng);
var _swipeableTabsPng = require("url:../pages/react-aria/examples//swipeable-tabs.png");
var _swipeableTabsPngDefault = parcelHelpers.interopDefault(_swipeableTabsPng);
var _swipeableTabsDarkPng = require("url:../pages/react-aria/examples//swipeable-tabs-dark.png");
var _swipeableTabsDarkPngDefault = parcelHelpers.interopDefault(_swipeableTabsDarkPng);
const images = {
    'ios-list.html': [
        (0, _iosListPngDefault.default),
        (0, _iosListDarkPngDefault.default)
    ],
    'emoji-picker.html': [
        (0, _emojiPickerPngDefault.default),
        (0, _emojiPickerDarkPngDefault.default)
    ],
    'kanban.html': [
        (0, _kanbanPngDefault.default),
        (0, _kanbanDarkPngDefault.default)
    ],
    'photos.html': [
        (0, _photosPngDefault.default),
        (0, _photosDarkPngDefault.default)
    ],
    'crud.html': [
        (0, _crudPngDefault.default),
        (0, _crudDarkPngDefault.default)
    ],
    'ripple-button.html': (0, _rippleButtonPngDefault.default),
    'sheet.html': [
        (0, _sheetPngDefault.default),
        (0, _sheetDarkPngDefault.default)
    ],
    'swipeable-tabs.html': [
        (0, _swipeableTabsPngDefault.default),
        (0, _swipeableTabsDarkPngDefault.default)
    ]
};
function ExampleList({ tag, pages }) {
    let examples = pages.filter((page)=>page.name.startsWith('react-aria/examples/') && !page.name.endsWith('index.html') && (!tag || page.exports?.keywords.includes(tag))).sort((a, b)=>getTitle(a).localeCompare(getTitle(b)));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
        itemScope: true,
        itemType: "https://schema.org/ItemList",
        className: " se12 DmDY7312 Uj12 qj12 JG12 Td12 Qd12 Sd12 Rd12 _Gc12 _Ca12 _Cpg12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                itemProp: "name",
                content: "Examples"
            }),
            examples.map((example)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    itemProp: "itemListElement",
                    itemScope: true,
                    itemType: "https://schema.org/ListItem",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sc12",
                        itemProp: "item",
                        itemScope: true,
                        itemType: "https://schema.org/TechArticle",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                                itemProp: "url",
                                content: example.url
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
                                href: example.url,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExampleImage, {
                                            name: example.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                slot: "title",
                                                itemProp: "headline",
                                                children: getTitle(example)
                                            }),
                                            example.exports?.description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                slot: "description",
                                                itemProp: "description",
                                                children: example.exports?.description
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, example.url))
        ]
    });
}
const getTitle = (example)=>example.tableOfContents?.[0]?.title;
const image = " Za12 fc12 _Hb12 _4c12 _Ob12";
function ExampleImage({ name }) {
    let img = images[(0, _pathDefault.default).basename(name)];
    if (!Array.isArray(img)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: img,
        alt: "",
        className: image
    });
    let [light, dark] = img;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("picture", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                srcSet: light,
                media: "(prefers-color-scheme: light)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                srcSet: dark,
                media: "(prefers-color-scheme: dark)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: light,
                alt: "",
                itemProp: "image",
                className: image
            })
        ]
    });
}

},{"0":"du7hS","1":"lPxgY","2":"8kfvX","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Card","jxfoI"],["CardPreview","jxfoI"],["Content","10r6w"],["Text","10r6w"]],"url:../pages/react-aria/examples/crud.png":"2smAH","url:../pages/react-aria/examples/crud-dark.png":"lzjFF","url:../pages/react-aria/examples/emoji-picker.png":"8YCgT","url:../pages/react-aria/examples/emoji-picker-dark.png":"c18aK","url:react-aria-components/docs/examples/ios-list.png":"1jx0H","url:../pages/react-aria/examples/ios-list-dark.png":"bk4yh","url:../pages/react-aria/examples/kanban.png":"iLi8Y","url:../pages/react-aria/examples/kanban-dark.png":"vjlUD","path":"fKFKY","url:../pages/react-aria/examples/photos.png":"gaMb5","url:../pages/react-aria/examples/photos-dark.png":"lSXrg","url:react-aria-components/docs/examples/ripple-button.png":"l5ARG","url:../pages/react-aria/examples/sheet.png":"guc3G","url:../pages/react-aria/examples/sheet-dark.png":"kyBLL","url:../pages/react-aria/examples//swipeable-tabs.png":"2UiVe","url:../pages/react-aria/examples//swipeable-tabs-dark.png":"91lqj","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"du7hS":[function() {},{}],"lPxgY":[function() {},{}],"8kfvX":[function() {},{}],"2smAH":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aeJCk");

},{}],"lzjFF":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5BqrR");

},{}],"8YCgT":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gsBhw");

},{}],"c18aK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cV9iZ");

},{}],"1jx0H":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("fcEYl");

},{}],"bk4yh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5cipT");

},{}],"iLi8Y":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7uoTh");

},{}],"vjlUD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("96Yok");

},{}],"fKFKY":[function(require,module,exports,__globalThis) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("c0743715070b1b8a");
'use strict';
function assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function _format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = process.cwd();
                path = cwd;
            }
            assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return posix.normalize(joined);
    },
    relative: function relative(from, to) {
        assertPath(from);
        assertPath(to);
        if (from === to) return '';
        from = posix.resolve(from);
        to = posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return _format('/', pathObject);
    },
    parse: function parse(path) {
        assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
posix.posix = posix;
module.exports = posix;

},{"c0743715070b1b8a":"4MqXt"}],"4MqXt":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"gaMb5":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jDbeZ");

},{}],"lSXrg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bKKfw");

},{}],"l5ARG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8WlUp");

},{}],"guc3G":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kKbHj");

},{}],"kyBLL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("d9Oph");

},{}],"2UiVe":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("l5zV9");

},{}],"91lqj":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1TKak");

},{}],"fw3EC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFileTrigger = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        "aria-hidden": "true",
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 102 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-600)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 102,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 101,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 15.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                transform: "translate(18 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Select a file"
                })
            })
        ]
    });
exports.default = SvgFileTrigger;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ejGAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFocusScope = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 104,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 104px)/2) 10px"
        },
        viewBox: "0 0 230 104",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "FocusScope_svg__a",
                    width: 230,
                    height: 104,
                    x: 0,
                    y: 0,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#FocusScope_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M220 96.5H10c-1.93 0-3.5-1.57-3.5-3.5V9c0-1.93 1.57-3.5 3.5-3.5h210c1.93 0 3.5 1.57 3.5 3.5v84c0 1.93-1.57 3.5-3.5 3.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "M10 6C8.346 6 7 7.346 7 9v84c0 1.654 1.346 3 3 3h210c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3zm0-1h210a4 4 0 0 1 4 4v84a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(18 17)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 194,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 192,
                                height: 28,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-900)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(29 37)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M29 22h1v19h-1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(18 55)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 194,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 193,
                                height: 29,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 4.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(29 75)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgFocusScope;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9IhhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgForm = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 132,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 152
        },
        viewBox: "0 0 220 132",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(19 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Email"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-600)",
                            transform: "translate(54)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 166,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 165,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "someone@example.com"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-700)",
                            d: "m202.612 5.147-7.434 13.302a.444.444 0 0 0 .388.662h14.869a.444.444 0 0 0 .388-.661l-7.438-13.303a.444.444 0 0 0-.775 0Zm1.273 11.964a.22.22 0 0 1-.222.222h-1.33a.22.22 0 0 1-.222-.222v-1.333a.22.22 0 0 1 .222-.222h1.334a.22.22 0 0 1 .222.222Zm0-2.667a.22.22 0 0 1-.222.222h-1.33a.22.22 0 0 1-.222-.222V9.111a.22.22 0 0 1 .222-.226h1.334a.22.22 0 0 1 .222.222Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(0 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Password"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(54 52)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 166,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 165,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 68)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(54 80)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 12,
                            height: 12,
                            fill: "var(--anatomy-gray-800)",
                            rx: 2,
                            transform: "translate(0 6)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M9.648 8.613a.92.92 0 0 0-1.294.156L4.794 13.3l-1.162-1.394a.922.922 0 0 0-1.416 1.18l1.89 2.269a1 1 0 0 0 .07.052 1 1 0 0 0 .07.083 1 1 0 0 0 .128.07 1 1 0 0 0 .095.051.9.9 0 0 0 .345.076.9.9 0 0 0 .357-.08 1 1 0 0 0 .1-.057 1 1 0 0 0 .129-.077 1 1 0 0 0 .069-.086c.02-.021.047-.03.066-.053L9.8 9.907a.92.92 0 0 0-.156-1.294Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(21 16)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Remember me"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(54 40)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "This account does not exist."
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(54 108)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 51,
                                    height: 24,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 50,
                                    height: 23,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-800)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(63 124)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Sign In"
                            })
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgForm;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5tyKX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 100,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 200 100",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 200,
                height: 100,
                fill: "none",
                stroke: "var(--anatomy-gray-400)",
                strokeDasharray: "4 4",
                rx: 6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                fontWeight: 600,
                transform: "translate(10 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Group Label"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(10 32)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 180,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        transform: "translate(10 18)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Item 1"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(10 64)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 180,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 13,
                        transform: "translate(10 18)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Item 2"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dau7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIcons = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 120 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M16 28S4 20 4 12c0-4 2-6 5-6 2 0 4 1 7 4 3-3 5-4 7-4 3 0 5 2 5 6 0 8-12 16-12 16M60 4l3 9 9 1-6 6 2 8-8-4-8 4 2-8-6-6 9-1Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(88)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        d: "m16 6 10 20H6Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 22,
                        r: 1.2,
                        fill: "var(--anatomy-gray-700)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "var(--anatomy-gray-700)",
                        strokeLinecap: "round",
                        strokeWidth: 2,
                        d: "M16 12v6"
                    })
                ]
            })
        ]
    });
exports.default = SvgIcons;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7yMTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIllustratedMessage = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 140,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "20px 10px"
        },
        viewBox: "0 0 140 140",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "M91.914 41.524c.002-.126.009-.25.009-.378 0-9.87-7.666-17.87-17.123-17.87-7.629 0-14.09 5.208-16.303 12.403a12 12 0 0 0-4.764-.987c-6.901 0-12.496 5.839-12.496 13.042 0 1.015.122 1.998.332 2.946-4.558 1.303-7.913 5.646-7.913 10.817 0 6.138 4.72 11.117 10.578 11.218v.01h46.739v-.003q.042.002.083.003c8.263 0 14.96-6.99 14.96-15.614 0-8.323-6.24-15.123-14.102-15.587"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fontFamily: "var(--anatomy-font)",
                textAnchor: "middle",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontSize: 14,
                        fontWeight: 600,
                        transform: "translate(70 100)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "No results"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-600)",
                        fontSize: 11,
                        transform: "translate(70 116)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Try another search"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgIllustratedMessage;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1GbxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIllustrations = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 96,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "30px 10px"
        },
        viewBox: "0 0 96 96",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--anatomy-gray-500)",
            d: "M69.914 41.524c.002-.126.009-.25.009-.378 0-9.87-7.666-17.87-17.123-17.87-7.629 0-14.09 5.208-16.303 12.403a12 12 0 0 0-4.764-.987c-6.901 0-12.496 5.839-12.496 13.042 0 1.015.122 1.998.332 2.946-4.558 1.303-7.913 5.646-7.913 10.817 0 6.138 4.72 11.117 10.578 11.218v.01h46.739v-.003q.042.002.083.003c8.263 0 14.96-6.99 14.96-15.614 0-8.323-6.24-15.123-14.102-15.587"
        })
    });
exports.default = SvgIllustrations;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2o53d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImage = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 90,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 120 90",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 120,
                height: 90,
                fill: "var(--anatomy-gray-300)",
                stroke: "var(--anatomy-gray-400)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M52 35h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H52a2 2 0 0 1-2-2V37a2 2 0 0 1 2-2m3 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3m14 9-5-5-3 3-4-4-6 6Z"
            })
        ]
    });
exports.default = SvgImage;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"H2J50":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInlineAlert = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 200 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 200,
                height: 48,
                fill: "var(--anatomy-gray-200)",
                stroke: "var(--anatomy-gray-400)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8,
                fill: "var(--anatomy-gray-600)",
                transform: "translate(8 16)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                fontWeight: 700,
                textAnchor: "middle",
                transform: "translate(16 28)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "i"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 140,
                height: 8,
                x: 32,
                y: 14,
                fill: "var(--anatomy-gray-500)",
                rx: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 110,
                height: 8,
                x: 32,
                y: 26,
                fill: "var(--anatomy-gray-400)",
                rx: 2
            })
        ]
    });
exports.default = SvgInlineAlert;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"klfEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInput = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 176 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "123 Any St."
                })
            })
        ]
    });
exports.default = SvgInput;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fOc8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInternationalizedDate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 38.739,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 38.739px)/2) 10px"
        },
        viewBox: "0 0 38 38.739",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-5 -2.761)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 17.393)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 23.915)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(11.957 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(18.48 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(25.002 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 4.348,
                    height: 4.348,
                    fill: "var(--anatomy-gray-500)",
                    rx: 1,
                    transform: "translate(31.524 30.437)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "none",
                    stroke: "var(--anatomy-gray-400)",
                    strokeWidth: 2.1,
                    transform: "translate(5 7.5)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 38,
                            height: 34,
                            stroke: "none",
                            rx: 4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 35.9,
                            height: 31.9,
                            x: 1.05,
                            y: 1.05,
                            rx: 2.95
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M35.872 7.609V4.348a1.087 1.087 0 0 0-1.087-1.087h-2.174a1.087 1.087 0 0 0-1.087 1.087v3.261H16.305V4.348a1.087 1.087 0 0 0-1.087-1.087h-2.17a1.087 1.087 0 0 0-1.091 1.087v3.261zM11.957 10.87v2.174a1.087 1.087 0 0 0 1.091 1.087h2.17a1.087 1.087 0 0 0 1.087-1.087V10.87h15.219v2.174a1.087 1.087 0 0 0 1.087 1.087h2.174a1.087 1.087 0 0 0 1.087-1.087V10.87"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M11.957 7.455h4.348v3.459h-4.348Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-600)",
                    d: "M31.524 7.455h4.348v3.459h-4.348Z"
                })
            ]
        })
    });
exports.default = SvgInternationalizedDate;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kjsQS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInternationalizedDefault = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 120 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "InternationalizedDefault_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M23.98 79.99c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.9 24 106.03 24 80.02Zm26.36-46.91c-.07-.17-.15-.33-.24-.49a55.6 55.6 0 0 1 12.37-5.84c.05.3.14.6.26.89 2.06 4.9 8.3 10.94 16.68 10.94 4.33 0 7.8-1.86 10.35-3.97 2.53-2.1 4.34-4.6 5.47-6.33.41-.63.62-1.34.65-2.04.69.2 1.37.42 2.05.65-.06.18-.1.37-.13.57-.67 4.46-1.44 10.7-.74 16.34.69 5.54 3.01 11.91 9.76 14.25 5.36 1.86 10.66.94 14.8-.9 2.74-1.22 5.23-2.96 7.07-4.9 2.11 3.7 3.81 7.65 5.04 11.81l-1.75-.36c-3.01-.59-7.06-1.26-11.28-1.54-4.16-.28-8.77-.19-12.78.91-4.02 1.1-8.1 3.44-9.84 8.13-4.86 13.11 1.7 21.06 3.39 22.75 2.55 2.55 5.17 3.75 7.1 4.62.23.11.46.21.67.31 1.86.87 3.19 1.63 4.54 3.58.47.67.94 1.89 1.3 3.74.34 1.8.52 3.89.58 6.11.07 2.2.02 4.41-.04 6.43l-.06 1.63c-.04 1.08-.07 2.1-.09 2.95a55.78 55.78 0 0 1-35.48 12.67c-2.09 0-4.15-.11-6.18-.34.44-.97.91-1.99 1.41-3.08.26-.55.52-1.12.79-1.71 1.15-2.49 2.37-5.21 3.44-7.97 2.05-5.28 3.89-11.54 2.82-16.9-.67-3.35-2.3-6.32-5.41-8.51-2.94-2.07-6.85-3.21-11.67-3.74-7.46-.83-10.89-1.6-14.01-4.09-2.9-2.32-3.62-4.43-3.74-5.93-.13-1.67.44-3.21 1-4.2.51-.9 1.72-1.68 4.44-1.97 2.35-.25 4.9-.03 7.3.18.31.03.62.05.93.08 2.86.24 5.98-.1 8.18-2.42 2.06-2.18 2.33-5.13 2.33-7.33 0-1.17.32-1.95.86-2.64.61-.79 1.63-1.6 3.26-2.51 2.83-1.57 4.87-4.32 5.4-7.4.56-3.26-.64-6.73-3.89-8.9-1.72-1.14-3.68-1.55-5.33-1.72-1.68-.17-3.48-.13-5.1-.08-.22 0-.44.01-.65.02-3.22.11-5.75.19-7.75-.38-.27-.08-.86-.38-1.74-1.22-.84-.8-1.72-1.89-2.58-3.15-1.73-2.53-3.12-5.37-3.79-7Zm73.36 81.97a55.8 55.8 0 0 0 12.32-35.06c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96m.28-69.78a56.3 56.3 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.96c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                        style: {
                            fill: "none"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: 55,
                height: 52,
                transform: "translate(32.5 38)",
                viewBox: "15 17 135 128",
                ...props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    clipPath: "url(#InternationalizedDefault_svg__a)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-500)",
                        d: "M15 17h135v128H15z"
                    })
                })
            })
        ]
    });
exports.default = SvgInternationalizedDefault;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a9loY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLabeledValue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 45,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 45px)/2) 10px"
        },
        viewBox: "0 0 55 45",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                transform: "translate(0 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Aperture"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 17,
                transform: "translate(0 41)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "f/1.5"
                })
            })
        ]
    });
exports.default = SvgLabeledValue;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6zU7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLabel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 24,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 24px)/2) 10px"
        },
        viewBox: "0 0 39 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
            fill: "var(--anatomy-gray-700)",
            fontFamily: "var(--anatomy-font)",
            fontSize: 12,
            transform: "translate(0 16)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                x: 0,
                y: 0,
                children: "Address"
            })
        })
    });
exports.default = SvgLabel;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"awi79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 17,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 17px)/2) 10px"
        },
        viewBox: "0 0 35 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
            fill: "var(--anatomy-gray-700)",
            fontFamily: "var(--anatomy-font)",
            fontSize: 14,
            textDecoration: "underline",
            transform: "translate(0 14)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                x: 0,
                y: 0,
                children: "About"
            })
        })
    });
exports.default = SvgLink;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g2KkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgListBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 239,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 152
        },
        viewBox: "0 0 214 239",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 1.5,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 214,
                        height: 239,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 212.5,
                        height: 237.5,
                        x: 0.75,
                        y: 0.75,
                        fill: "none",
                        rx: 5.25
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-900)",
                opacity: 0.04,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M1 31h212v64H1Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M2 32v62h210V32zm-1-1h212v64H1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 58)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 1"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 127)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 2"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M187.007 55.33a1.37 1.37 0 0 1-1.072-.513l-3.321-4a1.34 1.34 0 0 1 2.109-1.651l2.284 2.66 6.29-8a1.335 1.335 0 1 1 2.1 1.642l-7.353 9.348a1.3 1.3 0 0 1-1.037.514"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 83)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 152)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 20,
                transform: "translate(18 195)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Option 3"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fillOpacity: 0.75,
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                transform: "translate(18 220)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: ".06em",
                transform: "translate(18 22)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "SECTION TITLE"
                })
            })
        ]
    });
exports.default = SvgListBox;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8p8fn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgListView = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 152,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10
        },
        viewBox: "0 0 364 232",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 364,
                                height: 232,
                                stroke: "none",
                                rx: 6
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 362.5,
                                height: 230.5,
                                x: 0.75,
                                y: 0.75,
                                fill: "none",
                                rx: 5.25
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        fillOpacity: 0.1,
                        d: "M0 116h364v58H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 28)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Documents"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 58.5h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 116.522h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        strokeWidth: 1.5,
                        d: "M.5 174.522h363.252"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 63)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-700)",
                                    d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M331.252 21.5h15v15h-15z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-700)",
                                d: "M335.752 36.425a1.312 1.312 0 0 1-.922-2.246L340.072 29l-5.242-5.175a1.314 1.314 0 1 1 1.845-1.872l6.188 6.113a1.314 1.314 0 0 1 0 1.868l-6.188 6.113a1.3 1.3 0 0 1-.923.378"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 3,
                        transform: "translate(18 18.5)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 21,
                                height: 21,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 18,
                                height: 18,
                                x: 1.5,
                                y: 1.5,
                                fill: "none",
                                rx: 0.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 3,
                            transform: "translate(18 76.5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 21,
                                    height: 21,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 18,
                                    height: 18,
                                    x: 1.5,
                                    y: 1.5,
                                    fill: "none",
                                    rx: 0.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-700)",
                                stroke: "none",
                                strokeOpacity: 0,
                                transform: "translate(18 134.5)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 21,
                                        height: 21,
                                        rx: 2
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 20,
                                        height: 20,
                                        x: 0.5,
                                        y: 0.5,
                                        fill: "none",
                                        rx: 1.5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-75)",
                                d: "M26.682 151a1.5 1.5 0 0 1-1.182-.578l-3.432-4.499a1.5 1.5 0 1 1 2.364-1.845l2.25 2.986 5.886-7.486a1.5 1.5 0 1 1 2.364 1.845l-7.068 9a1.5 1.5 0 0 1-1.182.577"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 3,
                            transform: "translate(18 192.5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 21,
                                    height: 21,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 18,
                                    height: 18,
                                    x: 1.5,
                                    y: 1.5,
                                    fill: "none",
                                    rx: 0.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 122)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 179)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(276.252 5)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 48,
                                    height: 48,
                                    fill: "none",
                                    rx: 4,
                                    transform: "translate(-.252)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-700)",
                                        d: "M25.612 19.5A1.612 1.612 0 1 1 24 17.888a1.613 1.613 0 0 1 1.613 1.612Zm.138 9h-.25v-5.7a.3.3 0 0 0-.3-.3h-2.95s-.875.024-.875.75.875.75.875.75h.25v4.5h-.25s-.875.024-.875.75.875.75.875.75h3.5s.875-.025.875-.75-.875-.75-.875-.75M24 11.25A12.75 12.75 0 1 0 36.75 24 12.75 12.75 0 0 0 24 11.25m0 22.762A10.012 10.012 0 1 1 34.012 24 10.01 10.01 0 0 1 24 34.012"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 47)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "12 items"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 85)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Onboarding"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 105)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "PDF"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 143)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Budget"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 163)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "XLS"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 19,
                        transform: "translate(105 201)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Sales Pitch"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 15,
                        transform: "translate(105 221)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "PPT"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-200)",
                d: "M58.11 47.086a2.98 2.98 0 0 1-3.008-3.007V17.61a2.98 2.98 0 0 1 3.008-3.008h12.151a2.38 2.38 0 0 1 1.684.722l3.73 3.73a1.1 1.1 0 0 0 .842.361h12.874a2.98 2.98 0 0 1 3.011 3.007v21.657a2.98 2.98 0 0 1-3.008 3.008Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "M89.391 18.813H76.517c-.12 0-.241 0-.481-.241l-3.73-3.73A2.9 2.9 0 0 0 70.261 14H58.109a3.545 3.545 0 0 0-3.609 3.609v26.469a3.62 3.62 0 0 0 3.609 3.609h31.282A3.62 3.62 0 0 0 93 44.078V22.422a3.545 3.545 0 0 0-3.609-3.609M91.8 44.078a2.413 2.413 0 0 1-2.406 2.406H58.109a2.413 2.413 0 0 1-2.409-2.406V20.016h33.691a2.413 2.413 0 0 1 2.409 2.406Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-50)",
                d: "M60.907 107.033a3.26 3.26 0 0 1-3.256-3.256V69.911a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-500)",
                d: "m89.9 73.594-6.667-6.643A3.2 3.2 0 0 0 80.94 66H60.908A3.92 3.92 0 0 0 57 69.908v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908V75.9a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605V69.908a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M60.907 166.026a3.26 3.26 0 0 1-3.256-3.256v-33.866a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-500)",
                        d: "m89.9 132.587-6.667-6.643a3.2 3.2 0 0 0-2.293-.951H60.908A3.92 3.92 0 0 0 57 128.901v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908v-27.873a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605v-33.865a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M60.907 223.033a3.26 3.26 0 0 1-3.256-3.256v-33.866a3.26 3.26 0 0 1 3.256-3.259H80.94a2.6 2.6 0 0 1 1.838.759l6.673 6.649a2.63 2.63 0 0 1 .767 1.845v27.872a3.26 3.26 0 0 1-3.256 3.256Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-500)",
                        d: "m89.9 189.594-6.667-6.643A3.2 3.2 0 0 0 80.94 182H60.908A3.92 3.92 0 0 0 57 185.908v33.865a3.91 3.91 0 0 0 3.908 3.908h26.05a3.91 3.91 0 0 0 3.908-3.908V191.9a3.28 3.28 0 0 0-.966-2.306m-7.5-5.64 6.539 6.513h-5.888a.653.653 0 0 1-.651-.651Zm7.164 35.819a2.6 2.6 0 0 1-2.605 2.605H60.908a2.6 2.6 0 0 1-2.608-2.605v-33.865a2.613 2.613 0 0 1 2.608-2.608H80.94a.6.6 0 0 1 .156.013v6.5a1.96 1.96 0 0 0 1.954 1.954h6.5a.4.4 0 0 1 .013.13Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgListView;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bnXl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMcp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "4.5em",
        height: "4.5em",
        fill: "var(--anatomy-gray-700)",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M15.688 2.343a2.59 2.59 0 0 0-3.61 0l-9.626 9.44a.863.863 0 0 1-1.203 0 .823.823 0 0 1 0-1.18l9.626-9.44a4.313 4.313 0 0 1 6.016 0 4.12 4.12 0 0 1 1.204 3.54 4.3 4.3 0 0 1 3.609 1.18l.05.05a4.115 4.115 0 0 1 0 5.9l-8.706 8.537a.274.274 0 0 0 0 .393l1.788 1.754a.823.823 0 0 1 0 1.18.863.863 0 0 1-1.203 0l-1.788-1.753a1.92 1.92 0 0 1 0-2.754l8.706-8.538a2.47 2.47 0 0 0 0-3.54l-.05-.049a2.59 2.59 0 0 0-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 0 1-1.204 0 .823.823 0 0 1 0-1.18l7.273-7.133a2.47 2.47 0 0 0-.003-3.537"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M14.485 4.703a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a4.115 4.115 0 0 0 0 5.9 4.314 4.314 0 0 0 6.016 0l7.12-6.982a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a2.59 2.59 0 0 1-3.61 0 2.47 2.47 0 0 1 0-3.54z"
            })
        ]
    });
exports.default = SvgMcp;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8ru7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 151,
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 156 151",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Menu_svg__a",
                    width: 156,
                    height: 116,
                    x: 0,
                    y: 35,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 32,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 31,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        transform: "translate(6)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(14.2 14.4)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(20.05 14.4)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 1.7,
                                cy: 1.7,
                                r: 1.7,
                                transform: "translate(8.35 14.4)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#Menu_svg__a)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            transform: "translate(6 40)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 144,
                                    height: 104,
                                    stroke: "none",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 143,
                                    height: 103,
                                    x: 0.5,
                                    y: 0.5,
                                    fill: "none",
                                    rx: 3.5
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        fillOpacity: 0.04,
                        d: "M7 44h142v32H7z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 44h57v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 64)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Edit\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 76h82v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 96)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Rename\u2026"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "none",
                        d: "M18 108h72v32H18z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(18 128)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Delete\u2026"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgMenu;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lkbAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMeter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 34,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 34px)/2) 10px"
        },
        viewBox: "0 0 160 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 160,
                height: 6,
                fill: "var(--anatomy-gray-300)",
                rx: 3,
                transform: "translate(0 28)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M3 28h45v6H3a3 3 0 0 1-3-3 3 3 0 0 1 3-3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Storage space"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(160 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -21.852,
                    y: 0,
                    children: "30%"
                })
            })
        ]
    });
exports.default = SvgMeter;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b3GHr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgModal = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 180,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "30px 10px"
        },
        viewBox: "0 0 220 180",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Modal_svg__a",
                    width: 192,
                    height: 152,
                    x: 14,
                    y: 14,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Modal_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(20 20)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 180,
                            height: 140,
                            stroke: "none",
                            rx: 8
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 179,
                            height: 139,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 7.5
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 16,
                fontWeight: 600,
                transform: "translate(32 42)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Modal Title"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "var(--anatomy-gray-700)",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "m178 28 8 8m0-8-8 8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-300)",
                d: "M32 52h156v1H32z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-300)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 120,
                        height: 8,
                        x: 32,
                        y: 64,
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 140,
                        height: 8,
                        x: 32,
                        y: 76,
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 100,
                        height: 8,
                        x: 32,
                        y: 88,
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(0 122)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M32 0h156v1H32z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 40,
                        height: 20,
                        x: 102,
                        y: 12,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 39,
                        height: 19,
                        x: 102.5,
                        y: 12.5,
                        fill: "none",
                        stroke: "var(--anatomy-gray-400)",
                        rx: 3.5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        textAnchor: "middle",
                        transform: "translate(122 26)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 40,
                        height: 20,
                        x: 148,
                        y: 12,
                        fill: "var(--anatomy-gray-700)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "#fff",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        textAnchor: "middle",
                        transform: "translate(168 26)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgModal;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"flFdy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNumberField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Width"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "4 in"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M152 24h20a4 4 0 0 1 4 4v12.5h-24z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M152.5 24.5H172a3.5 3.5 0 0 1 3.5 3.5v12h-23V24.5Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-400)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "none",
                                d: "M152 39.5h24V52a4 4 0 0 1-4 4h-20z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "none",
                                d: "M152.5 40h23v12a3.5 3.5 0 0 1-3.5 3.5h-19.5V40Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-800)",
                        d: "M164 30.5a.76.76 0 0 0-.5.2l-3.3 3.3a.76.76 0 0 0-.2.5.713.713 0 0 0 .8.7.55.55 0 0 0 .5-.2l2.7-2.7 2.7 2.7a.55.55 0 0 0 .5.2.713.713 0 0 0 .8-.7.76.76 0 0 0-.2-.5l-3.2-3.2a.86.86 0 0 0-.6-.3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-800)",
                        d: "M164 49.5a.76.76 0 0 0 .5-.2l3.3-3.3a.76.76 0 0 0 .2-.5.713.713 0 0 0-.8-.7.55.55 0 0 0-.5.2l-2.7 2.7-2.7-2.7a.55.55 0 0 0-.5-.2.713.713 0 0 0-.8.7.76.76 0 0 0 .2.5l3.2 3.2a.86.86 0 0 0 .6.3"
                    })
                ]
            })
        ]
    });
exports.default = SvgNumberField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5TMfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPicker = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            width: "calc(100% - 20px)",
            padding: 10,
            maxHeight: 205
        },
        viewBox: "0 0 188 205",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Picker_svg__a",
                    width: 188,
                    height: 148,
                    x: 0,
                    y: 57,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(6 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Favorite color"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-200)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(6 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Orange"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                d: "M169.99 38.01a1 1 0 0 0-1.707-.71L165 40.586l-3.283-3.286a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Picker_svg__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(6 62)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 176,
                            height: 136,
                            stroke: "none",
                            rx: 4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 175,
                            height: 135,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 3.5
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                fillOpacity: 0.04,
                d: "M7 98h174v32H7z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 66h46v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 86)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Red"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 98h66v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 118)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Orange"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 130h61v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 150)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Yellow"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M18 162h59v32H18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 182)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Green"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M164.5 118a1.02 1.02 0 0 1-.8-.384l-2.488-3a1 1 0 0 1 1.577-1.233l1.711 1.993 4.712-5.991a1 1 0 1 1 1.576 1.23l-5.511 7a.98.98 0 0 1-.777.385"
            })
        ]
    });
exports.default = SvgPicker;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2P2zw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPopover = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 148,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 148px)/2) 10px"
        },
        viewBox: "0 0 251.999 148",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "Popover_svg__a",
                    width: 251.999,
                    height: 123.001,
                    x: 0,
                    y: 0,
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: 2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0.149
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#Popover_svg__a)",
                transform: "translate(-.001)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m94 115.293-7.646-7.647-.147-.146H10c-1.93 0-3.5-1.57-3.5-3.5V8.999c0-1.93 1.57-3.5 3.5-3.5h232c1.93 0 3.5 1.57 3.5 3.5v95c0 1.93-1.57 3.5-3.5 3.5H101.794l-.147.147z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-400)",
                            d: "m94 114.586 7.587-7.586H242c1.654 0 3-1.346 3-3V8.999c0-1.654-1.346-3-3-3H10C8.346 6 7 7.346 7 9v95c0 1.655 1.346 3 3 3h76.415zM94 116l-8-8H10a4 4 0 0 1-4-4V8.999a4 4 0 0 1 4-4h232a4 4 0 0 1 4 4v95a4 4 0 0 1-4 4H102z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 15,
                fontWeight: 700,
                transform: "translate(17.999 13)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 16,
                    children: "Properties"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-200)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(81.999 124)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 24,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 23,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-900)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M100.888 130.666h-7.822a2.222 2.222 0 0 0-4.356 0h-1.6a.22.22 0 0 0-.222.223v.444a.22.22 0 0 0 .222.222h1.6a2.222 2.222 0 0 0 4.356 0h7.822a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223m-10 1.778a1.333 1.333 0 1 1 1.333-1.333 1.333 1.333 0 0 1-1.333 1.333"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M100.888 139.555h-6.044a2.222 2.222 0 0 0-4.356 0H87.11a.22.22 0 0 0-.222.223v.444a.22.22 0 0 0 .222.222h3.378a2.222 2.222 0 0 0 4.356 0h6.044a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223m-8.222 1.778A1.333 1.333 0 1 1 93.999 140a1.333 1.333 0 0 1-1.333 1.333"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M86.888 135.334v.444a.22.22 0 0 0 .222.222h7.822a2.222 2.222 0 0 0 4.356 0h1.6a.22.22 0 0 0 .222-.222v-.444a.22.22 0 0 0-.222-.223h-1.6a2.222 2.222 0 0 0-4.356 0H87.11a.22.22 0 0 0-.222.223m8.889.222a1.333 1.333 0 1 1 1.333 1.333 1.333 1.333 0 0 1-1.333-1.333"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(17.999 57)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Width"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(60.999 41)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 173,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 172,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(67.999 57)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "250 px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 12,
                            transform: "translate(17.999 87)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Height"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-400)",
                        transform: "translate(60.999 71)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 173,
                                height: 24,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 172,
                                height: 23,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(67.999 87)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "100 px"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgPopover;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1rojz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressBar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 34,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 34px)/2) 10px"
        },
        viewBox: "0 0 160 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 160,
                height: 6,
                fill: "var(--anatomy-gray-300)",
                rx: 3,
                transform: "translate(0 28)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M3 28h93v6H3a3 3 0 0 1-3-3 3 3 0 0 1 3-3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Loading..."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(160 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -22.476,
                    y: 0,
                    children: "60%"
                })
            })
        ]
    });
exports.default = SvgProgressBar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4067p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressCircle = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,0,0,0)",
                stroke: "var(--anatomy-gray-300)",
                strokeWidth: 3,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 16,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 14.5,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "M16 0a16 16 0 0 1 13.772 7.855 16 16 0 0 1 .249 15.853l-2.629-1.445a13 13 0 0 0-.2-12.88A13 13 0 0 0 16 3Z"
            })
        ]
    });
exports.default = SvgProgressCircle;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lj97x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRadioGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 120px)/2) 10px"
        },
        viewBox: "0 0 72 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 5,
                        transform: "translate(0 33)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 4.5,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 44)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 65)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 6,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 76)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 2,
                        transform: "translate(0 97)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 7,
                                stroke: "none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: 7,
                                cy: 7,
                                r: 6,
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(24 108)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Large"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-700)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    transform: "translate(0 16)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 0,
                        children: "Size"
                    })
                })
            })
        ]
    });
exports.default = SvgRadioGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kkyyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRangeCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            maxHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "102 0 300 182",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-236 -34)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M608 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M568 183a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M369 183a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144h200v32H408z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M369 183h199v32H369z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 18,
                    fontWeight: 700,
                    transform: "translate(489 52)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -60.426,
                        y: 0,
                        children: "September 2021"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(369 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(411 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.986,
                        y: 0,
                        children: "M"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(449 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(490 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.13,
                        y: 0,
                        children: "W"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(529 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.24,
                        y: 0,
                        children: "T"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(568 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.048,
                        y: 0,
                        children: "F"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.36,
                        y: 0,
                        children: "5"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.045,
                        y: 0,
                        children: "7"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.57,
                        y: 0,
                        children: "8"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.633,
                        y: 0,
                        children: "9"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "10"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.048,
                        y: 0,
                        children: "13"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.174,
                        y: 0,
                        children: "14"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.971,
                        y: 0,
                        children: "15"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.349,
                        y: 0,
                        children: "16"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.23,
                        y: 0,
                        children: "19"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.378,
                        y: 0,
                        children: "20"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.013,
                        y: 0,
                        children: "21"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.203,
                        y: 0,
                        children: "22"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.231,
                        y: 0,
                        children: "23"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.147,
                        y: 0,
                        children: "24"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.24,
                        y: 0,
                        children: "1"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.304,
                        y: 0,
                        children: "2"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.388,
                        y: 0,
                        children: "3"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m365.562 46.329 3.535-3.535a1 1 0 0 1 1.415 0 1 1 0 0 1 0 1.414l-2.829 2.828 2.829 2.828a1 1 0 0 1 0 1.415 1 1 0 0 1-1.415 0l-3.535-3.536a1 1 0 0 1-.293-.707 1 1 0 0 1 .293-.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.343,
                        y: 0,
                        children: "26"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.832,
                        y: 0,
                        children: "27"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(488 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.329,
                        y: 0,
                        children: "29"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(528 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.455,
                        y: 0,
                        children: "30"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.836,
                        y: 0,
                        children: "6"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(448 284)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.252,
                        y: 0,
                        children: "28"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-300)",
                    d: "M408 144a16 16 0 1 1-16 16 16 16 0 0 1 16-16"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: ".06em",
                    transform: "translate(608 91)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -2.976,
                        y: 0,
                        children: "S"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -4.9,
                        y: 0,
                        children: "11"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -6.195,
                        y: 0,
                        children: "18"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 244)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -7.154,
                        y: 0,
                        children: "25"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(608 124)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.514,
                        y: 0,
                        children: "4"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "var(--anatomy-gray-700)",
                    d: "m610.243 47.742-3.535 3.535a1 1 0 0 1-1.415 0 1 1 0 0 1 0-1.414l2.829-2.828-2.829-2.828a1 1 0 0 1 0-1.415 1 1 0 0 1 1.415 0l3.535 3.536a1 1 0 0 1 .293.707 1 1 0 0 1-.293.707"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-800)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(368 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.985,
                        y: 0,
                        children: "12"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(552 183)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(568 204)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -5.733,
                        y: 0,
                        children: "17"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 32,
                    height: 32,
                    fill: "var(--anatomy-gray-700)",
                    rx: 16,
                    transform: "translate(392 144)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 14,
                    letterSpacing: ".06em",
                    transform: "translate(408 164)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: -3.689,
                        y: 0,
                        children: "6"
                    })
                })
            ]
        })
    });
exports.default = SvgRangeCalendar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"exnCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRangeSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 200 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Price range"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M1 31h47v2H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M149 31h50a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-50z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M72 31h53v2H72z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(129 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(200 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -68.656,
                    y: 0,
                    children: "$100 \u2013 $300"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(52 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            })
        ]
    });
exports.default = SvgRangeSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ieIqO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReactAriaDefault = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 120,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 120 120",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "ReactAriaDefault_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M80 136c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56m8.48-86.3c0 4.69-3.8 8.48-8.48 8.48s-8.48-3.8-8.48-8.48 3.8-8.48 8.48-8.48 8.48 3.8 8.48 8.48M51.09 61.78c.52-1.8 2.39-2.85 4.2-2.33a89.87 89.87 0 0 0 48.82.17l.64-.18c1.81-.5 3.68.55 4.18 2.36a3.39 3.39 0 0 1-2.36 4.18l-.64.18a97 97 0 0 1-15.51 2.98c-1.03.11-1.82.97-1.82 2.01v14.89c0 .18.03.37.08.55 1.37 4.83 2.94 10.39 4.32 15.27.98 3.46 1.86 6.58 2.49 8.85.32 1.14.58 2.06.76 2.71l.04.15c.13.48.27.97.31 1.16a3.38 3.38 0 0 1-2.66 3.99 3.38 3.38 0 0 1-3.99-2.66c.02.09 0 .04-.08-.27q-.06-.195-.15-.54c-.18-.65-.44-1.57-.76-2.7-.64-2.27-1.52-5.39-2.49-8.85l-3.74-13.21a1.99 1.99 0 0 0-1.92-1.45h-1.6c-.89 0-1.68.59-1.92 1.45-1.22 4.3-2.55 9.01-3.74 13.21-.98 3.46-1.85 6.58-2.49 8.85-.32 1.13-.58 2.06-.76 2.7q-.09.345-.15.54c-.09.31-.1.36-.08.27a3.39 3.39 0 1 1-6.65-1.33c.04-.18.18-.68.31-1.16l.04-.15c.18-.65.44-1.58.76-2.71.64-2.27 1.52-5.39 2.49-8.85 1.38-4.88 2.95-10.44 4.32-15.27.05-.18.08-.36.08-.55V71.16c0-1.04-.79-1.9-1.82-2.01a96.5 96.5 0 0 1-16.17-3.17 3.395 3.395 0 0 1-2.33-4.2Z",
                        style: {
                            fill: "none"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: 55,
                height: 53,
                transform: "translate(32.5 38)",
                viewBox: "15.79 17.64 131.21 126.14",
                ...props,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 80,
                        cy: 80,
                        r: 50.83,
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        clipPath: "url(#ReactAriaDefault_svg__a)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-500)",
                            d: "M15.79 17.64H147v126.14H15.79z"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgReactAriaDefault;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7ohvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSearchField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Search"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(31 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Hawaii"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(144 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 16,
                        cy: 16,
                        r: 16,
                        fill: "rgba(0,0,0,0)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "m17.238 16 2.456-2.456a.875.875 0 0 0-1.237-1.238L16 14.762l-2.457-2.456a.875.875 0 0 0-1.237 1.238L14.762 16l-2.456 2.456a.875.875 0 1 0 1.237 1.238L16 17.238l2.457 2.456a.875.875 0 1 0 1.237-1.238Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "m22.744 45.429-3.455-3.454a5.7 5.7 0 1 0-1.314 1.314l3.454 3.454a.933.933 0 0 0 1.315-1.315Zm-12.077-6.762a4 4 0 1 1 4 4 4 4 0 0 1-4-4"
                    })
                })
            })
        ]
    });
exports.default = SvgSearchField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6r9pK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSegmentedControl = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 180 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-200)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 180,
                        height: 32,
                        stroke: "none",
                        rx: 8
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 179,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 7.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                stroke: "rgba(0,0,0,0)",
                transform: "translate(2 2)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 58,
                        height: 28,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 57,
                        height: 27,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 5.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(31 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Day"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(90 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Week"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                fontWeight: 600,
                textAnchor: "middle",
                transform: "translate(149 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Month"
                })
            })
        ]
    });
exports.default = SvgSegmentedControl;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"51dMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSelectBoxGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 180,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "30px 10px"
        },
        viewBox: "0 0 240 180",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 110,
                        height: 80,
                        fill: "var(--anatomy-gray-200)",
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 108,
                        height: 78,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "none",
                        strokeWidth: 1.5,
                        transform: "translate(10 10)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M3.5 7 6 9.5l4.5-5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 34,
                        height: 24,
                        x: 38,
                        y: 22,
                        fill: "var(--anatomy-gray-500)",
                        stroke: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 50,
                        height: 6,
                        x: 30,
                        y: 54,
                        fill: "var(--anatomy-gray-600)",
                        stroke: "none",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                transform: "translate(130)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 110,
                        height: 80,
                        fill: "var(--anatomy-gray-200)",
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 108,
                        height: 78,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "none",
                        strokeWidth: 1.5,
                        rx: 2,
                        transform: "translate(10 10)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 34,
                        height: 24,
                        x: 38,
                        y: 22,
                        stroke: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 50,
                        height: 6,
                        x: 30,
                        y: 54,
                        fill: "var(--anatomy-gray-500)",
                        stroke: "none",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                transform: "translate(0 100)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 110,
                        height: 80,
                        fill: "var(--anatomy-gray-200)",
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 108,
                        height: 78,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "none",
                        strokeWidth: 1.5,
                        rx: 2,
                        transform: "translate(10 10)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 34,
                        height: 24,
                        x: 38,
                        y: 22,
                        stroke: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 50,
                        height: 6,
                        x: 30,
                        y: 54,
                        fill: "var(--anatomy-gray-500)",
                        stroke: "none",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                transform: "translate(130 100)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 110,
                        height: 80,
                        fill: "var(--anatomy-gray-200)",
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 108,
                        height: 78,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "none",
                        strokeWidth: 1.5,
                        rx: 2,
                        transform: "translate(10 10)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 34,
                        height: 24,
                        x: 38,
                        y: 22,
                        stroke: "none",
                        rx: 3
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 50,
                        height: 6,
                        x: 30,
                        y: 54,
                        fill: "var(--anatomy-gray-500)",
                        stroke: "none",
                        rx: 2
                    })
                ]
            })
        ]
    });
exports.default = SvgSelectBoxGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l7OQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSelection = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1610 -1745)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-800)",
                    transform: "translate(1610 1745)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "var(--anatomy-gray-50)",
                    stroke: "var(--anatomy-gray-400)",
                    transform: "translate(1610 1803)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 231,
                            height: 50,
                            stroke: "none",
                            rx: 6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 230,
                            height: 49,
                            x: 0.5,
                            y: 0.5,
                            fill: "none",
                            rx: 5.5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(1622 1754)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 14,
                            height: 14,
                            fill: "var(--anatomy-gray-800)",
                            rx: 2,
                            transform: "translate(0 9)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M11.1 12.19a.96.96 0 0 0-1.347.162l-4.108 5.233-1.417-1.7a.96.96 0 0 0-1.475 1.228l2.177 2.613c.02.024.049.032.07.054a1 1 0 0 0 .074.086 1 1 0 0 0 .134.072 1 1 0 0 0 .1.054 1 1 0 0 0 .358.079 1 1 0 0 0 .372-.084 1 1 0 0 0 .1-.059 1 1 0 0 0 .14-.08 1 1 0 0 0 .072-.09c.02-.02.049-.03.068-.054l4.849-6.166a.96.96 0 0 0-.167-1.348"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 179,
                    height: 20,
                    fill: "var(--anatomy-gray-300)",
                    rx: 4,
                    transform: "translate(1648 1760)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 179,
                    height: 20,
                    fill: "var(--anatomy-gray-200)",
                    rx: 4,
                    transform: "translate(1648 1818)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(1622 1821)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    })
                })
            ]
        })
    });
exports.default = SvgSelection;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"32sE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSkeleton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 80,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "50px 10px"
        },
        viewBox: "0 0 200 80",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fill: "var(--anatomy-gray-300)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 200,
                    height: 12,
                    rx: 2
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 180,
                    height: 12,
                    y: 20,
                    rx: 2
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 160,
                    height: 12,
                    y: 40,
                    rx: 2
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 12,
                    cy: 12,
                    r: 12,
                    transform: "translate(0 56)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 80,
                    height: 12,
                    x: 32,
                    y: 62,
                    rx: 2
                })
            ]
        })
    });
exports.default = SvgSkeleton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"rQclf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSlider = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 200 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Exposure"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M1 31h142v2H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M167 31h32a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-32z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-700)",
                d: "M100 31h43v2h-43z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "rgba(255,255,255,0)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(147 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 8,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 8,
                        cy: 8,
                        r: 7,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(200 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: -21.7,
                    y: 0,
                    children: "+20"
                })
            })
        ]
    });
exports.default = SvgSlider;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fFIzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStatusLight = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 46 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 4,
                r: 4,
                fill: "var(--anatomy-gray-600)",
                transform: "translate(0 12)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(18 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Draft"
                })
            })
        ]
    });
exports.default = SvgStatusLight;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cpk35":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSwitch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 137 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 26,
                height: 14,
                fill: "var(--anatomy-gray-700)",
                rx: 7,
                transform: "translate(0 9)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-700)",
                strokeWidth: 2,
                transform: "translate(12 9)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 7,
                        cy: 7,
                        r: 7,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 7,
                        cy: 7,
                        r: 6,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(36 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Low power mode"
                })
            })
        ]
    });
exports.default = SvgSwitch;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bnlGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTable = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 173,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            minHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "0 0 300 173",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-600)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: ".06em",
                        transform: "translate(264.996 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -21.791,
                            y: 0,
                            children: "SIZE"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M296 172.5H4c-1.93 0-3.5-1.124-3.5-2.505V34.005C.5 32.624 2.07 31.5 4 31.5h292c1.93 0 3.5 1.124 3.5 2.505v135.99c0 1.381-1.57 2.505-3.5 2.505"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M4 32c-1.626 0-3 .918-3 2.005v135.99C1 171.082 2.374 172 4 172h292c1.626 0 3-.918 3-2.005V34.005c0-1.087-1.374-2.005-3-2.005zm0-1h292c2.21 0 4 1.346 4 3.005v135.99c0 1.66-1.79 3.005-4 3.005H4c-2.21 0-4-1.346-4-3.005V34.005C0 32.345 1.79 31 4 31"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 59)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.1,
                            y: 0,
                            children: "214 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M1 78h298v1H1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M1 125h298v1H1zM1 172h298v1H1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 106)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.324,
                            y: 0,
                            children: "120 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(281 153)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: -37.156,
                            y: 0,
                            children: "139 KB"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 60)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Proposal"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 107)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Budget"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-800)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(53 154)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Onboarding"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-600)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: ".06em",
                        transform: "translate(50.996 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "FILE NAME"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-600)",
                        d: "M278 17a1 1 0 0 0-1.71-.71l-1.29 1.3V12a1 1 0 1 0-2 0v5.59l-1.29-1.3a1.004 1.004 0 0 0-1.42 1.42l3 3a1 1 0 0 0 1.41 0l3-3a1 1 0 0 0 .3-.71"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        strokeWidth: 2,
                        transform: "translate(17 48)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                stroke: "none",
                                rx: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 12,
                                height: 12,
                                x: 1,
                                y: 1,
                                fill: "none",
                                rx: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 142)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 95)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            strokeWidth: 2,
                            transform: "translate(17 48)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 14,
                                    height: 14,
                                    stroke: "none",
                                    rx: 2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 12,
                                    height: 12,
                                    x: 1,
                                    y: 1,
                                    fill: "none",
                                    rx: 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-300)",
                        d: "M222 31h1v142h-1z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(17)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 14,
                                height: 14,
                                fill: "var(--anatomy-gray-700)",
                                rx: 2,
                                transform: "translate(0 9)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-75)",
                                d: "M10 15H4a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(17 39)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 14,
                        fill: "var(--anatomy-gray-700)",
                        rx: 2,
                        transform: "translate(0 9)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-75)",
                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                        })
                    })
                ]
            })
        ]
    });
exports.default = SvgTable;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"blsK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTabs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 32px)/2) 10px"
        },
        viewBox: "0 0 270 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 270,
                height: 2,
                fill: "var(--anatomy-gray-300)",
                rx: 1,
                transform: "translate(0 30)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 66,
                height: 2,
                fill: "var(--anatomy-gray-900)",
                rx: 1,
                transform: "translate(0 30)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-900)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(26 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Photos"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9 13a3 3 0 1 0 3 3 3 3 0 0 0-3-3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16.5 11h-3.025L11.8 9.163A.5.5 0 0 0 11.429 9H6.57a.5.5 0 0 0-.37.163L4.525 11H1.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M9 20.1a4.1 4.1 0 1 1 4.1-4.1A4.1 4.1 0 0 1 9 20.1"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(116 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Videos"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-700)",
                            d: "m106.2 12.1-4.2 3.15v-3.341a.91.91 0 0 0-.909-.909h-8.182a.91.91 0 0 0-.909.909v8.182a.91.91 0 0 0 .909.909h8.182a.91.91 0 0 0 .909-.909V16.75l4.2 3.15a.5.5 0 0 0 .8-.4v-7a.5.5 0 0 0-.8-.4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        transform: "translate(204 20)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Documents"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M188 12.5V8h-6.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V13h-4.5a.5.5 0 0 1-.5-.5"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M189 8h.043a.5.5 0 0 1 .353.146l3.458 3.454a.5.5 0 0 1 .146.357V12h-4Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgTabs;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8kpp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTagGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            height: 150,
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 130px)/2) 10px",
            width: "calc(100% - 20px)",
            borderRadius: 4
        },
        viewBox: "0 -20 415 220",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-75)",
                stroke: "var(--anatomy-gray-600)",
                transform: "translate(67.653 85.595)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 148.873,
                        height: 45.807,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 147.873,
                        height: 44.807,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 21,
                transform: "translate(86.739 114.23)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Traveling"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-600)",
                d: "m199.953 113.142-4.644-4.644 4.644-4.644a1.193 1.193 0 0 0-1.687-1.687l-4.644 4.644-4.643-4.644a1.194 1.194 0 1 0-1.688 1.688l4.644 4.643-4.644 4.644a1.193 1.193 0 0 0 1.687 1.687l4.644-4.644 4.644 4.644a1.193 1.193 0 0 0 1.687-1.687"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-75)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(220.343 85.595)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 124.061,
                                height: 45.807,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 123.061,
                                height: 44.807,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 21,
                        transform: "translate(239.429 114.23)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "Hiking"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "var(--anatomy-gray-600)",
                            d: "m327.421 113.142-4.644-4.644 4.644-4.644a1.193 1.193 0 0 0-1.687-1.687l-4.644 4.644-4.643-4.644a1.194 1.194 0 1 0-1.688 1.688l4.644 4.643-4.644 4.644a1.193 1.193 0 0 0 1.687 1.687l4.644-4.644 4.644 4.644a1.193 1.193 0 0 0 1.687-1.687"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 21,
                transform: "translate(66.763 64.372)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Categories"
                })
            })
        ]
    });
exports.default = SvgTagGroup;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aIwiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTextArea = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 80,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 80px)/2) 10px"
        },
        viewBox: "0 0 176 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Comment"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 56,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 55,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 30)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 14,
                        children: "Lorem ipsum dolor sit "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        x: 0,
                        y: 32,
                        children: "amet, consectetur "
                    })
                ]
            })
        ]
    });
exports.default = SvgTextArea;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"40HrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTextField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 56,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 56px)/2) 10px"
        },
        viewBox: "0 0 176 56",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-700)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 12,
                transform: "translate(0 16)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Address"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                transform: "translate(0 24)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 175,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(12 44)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "123 Any St."
                })
            })
        ]
    });
exports.default = SvgTextField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bc9cR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTimeField = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "10px calc((100% - 176px)/2)",
            height: "calc(151px - 20px)",
            width: 176
        },
        viewBox: "8 53 264 52",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-341 -39)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            fill: "var(--anatomy-gray-50)",
                            stroke: "var(--anatomy-gray-400)",
                            strokeWidth: 1.5,
                            transform: "translate(349 104)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 264,
                                    height: 48,
                                    stroke: "none",
                                    rx: 6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: 262.5,
                                    height: 46.5,
                                    x: 0.75,
                                    y: 0.75,
                                    fill: "none",
                                    rx: 5.25
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                            fill: "var(--anatomy-gray-700)",
                            fontFamily: "var(--anatomy-font)",
                            fontSize: 18,
                            transform: "translate(349 92)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                x: 0,
                                y: 0,
                                children: "Appointment time"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 23,
                    height: 26,
                    fill: "var(--anatomy-gray-700)",
                    rx: 2,
                    transform: "translate(366 115)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                    fill: "var(--anatomy-gray-50)",
                    fontFamily: "var(--anatomy-font)",
                    fontSize: 21,
                    transform: "translate(367 134)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            x: 3,
                            y: 0,
                            children: "12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            xmlSpace: "preserve",
                            y: 0,
                            fill: "var(--anatomy-gray-700)",
                            children: " : 45 PM"
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgTimeField;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4qrBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgToast = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 48,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 48px)/2) 10px"
        },
        viewBox: "0 0 214 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 214,
                height: 48,
                fill: "var(--anatomy-gray-600)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "none",
                transform: "translate(174 8)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "m191.343 24 3.4-3.4a.95.95 0 1 0-1.343-1.338l-3.4 3.395-3.4-3.4a.95.95 0 1 0-1.338 1.343l3.396 3.4-3.4 3.4a.95.95 0 1 0 1.342 1.338l3.4-3.395 3.4 3.395a.95.95 0 1 0 1.339-1.338Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M184 18h12v12h-12z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1,
                height: 32,
                fill: "#fff",
                fillOpacity: 0.25,
                rx: 0.5,
                transform: "translate(165 8)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "#fff",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(42 14)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 14,
                    children: "Analysis complete!"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M25 16a8 8 0 1 0 8 8 8 8 0 0 0-8-8m5.333 4.54-6.324 8.13a.6.6 0 0 1-.438.231h-.036a.6.6 0 0 1-.424-.175l-3.893-3.9a.6.6 0 0 1 0-.849l.663-.662a.6.6 0 0 1 .849 0l2.67 2.675 5.257-6.755a.6.6 0 0 1 .842-.1l.728.569a.6.6 0 0 1 .105.84Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "none",
                d: "M16 15h18v18H16z"
            })
        ]
    });
exports.default = SvgToast;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ljWCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgToggleButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 62 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-200)",
                stroke: "rgba(0,0,0,0)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 62,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 61,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M4 0h54a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m12.823 18 1.189 1.19-5.05 5.01L7 25l.822-1.987Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M18.977 20.16 19 17.144 23.146 13l1.135-.011a.726.726 0 0 0 .5-1.24l-2.26-2.269-2.271-2.238a.723.723 0 0 0-1.234.505L19 8.854 14.853 13l-3.012.022a.723.723 0 0 0-.554 1.233l3.229 3.229 3.229 3.229a.721.721 0 0 0 1.231-.554Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-800)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 14,
                transform: "translate(32 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "Pin"
                })
            })
        ]
    });
exports.default = SvgToggleButton;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8vOSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgToolbar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 32,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "60px 10px"
        },
        viewBox: "0 0 222 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 222,
                        height: 32,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 221,
                        height: 31,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(4 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-700)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeWidth: 1.5,
                        d: "M6 8h12M6 12h8m-8 4h12"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(32 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "var(--anatomy-gray-700)",
                        strokeLinecap: "round",
                        strokeWidth: 1.5,
                        d: "M6 8h12M8 12h8M6 16h12"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(60 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "var(--anatomy-gray-700)",
                        strokeLinecap: "round",
                        strokeWidth: 1.5,
                        d: "M6 8h12m-8 4h8M6 16h12"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M90 6h1v20h-1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(97 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        textAnchor: "middle",
                        transform: "translate(12 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "B"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(125 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontStyle: "italic",
                        fontWeight: 700,
                        textAnchor: "middle",
                        transform: "translate(12 16)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "I"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(153 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-700)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 14,
                        fontWeight: 700,
                        textAnchor: "middle",
                        transform: "translate(12 15)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0,
                            children: "U"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "var(--anatomy-gray-700)",
                        strokeWidth: 1.5,
                        d: "M7 18h10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-400)",
                d: "M183 6h1v20h-1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(190 4)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 12,
                        cy: 8,
                        r: 1.5,
                        fill: "var(--anatomy-gray-700)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 12,
                        cy: 12,
                        r: 1.5,
                        fill: "var(--anatomy-gray-700)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 12,
                        cy: 16,
                        r: 1.5,
                        fill: "var(--anatomy-gray-700)"
                    })
                ]
            })
        ]
    });
exports.default = SvgToolbar;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i9JRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTooltip = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 66,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 66px)/2) 10px"
        },
        viewBox: "0 0 39 66",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 39,
                        height: 24,
                        fill: "var(--anatomy-gray-700)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-700)",
                        d: "M16 24h8l-4 4Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-50)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 12,
                        transform: "translate(10 4)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 12,
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-500)",
                        transform: "translate(3 34)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 32,
                                height: 32,
                                stroke: "none",
                                rx: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 31,
                                height: 31,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 3.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M26.784 45.1 23.9 42.216a.6.6 0 0 0-.433-.176h-.017a.69.69 0 0 0-.464.2L12.542 52.686a.5.5 0 0 0-.126.211l-1.388 4.653c-.057.188.229.426.391.426h.031c.138-.031 3.933-1.172 4.656-1.389a.5.5 0 0 0 .207-.125l10.444-10.448a.7.7 0 0 0 .2-.441.6.6 0 0 0-.173-.473M15.7 55.658c-1.081.325-2.431.733-3.365 1.011l1-3.365Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgTooltip;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2jbL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTree = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 173,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: 10,
            minHeight: 152,
            boxSizing: "border-box"
        },
        viewBox: "0 0 301 188",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "Tree_svg__a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0h301v188H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#Tree_svg__a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-100)",
                        d: "M0 0h301v188H0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M296 186.5H4c-1.93 0-3.5-1.551-3.5-3.458V3.958C.5 2.05 2.07.5 4 .5h292c1.93 0 3.5 1.551 3.5 3.458v179.084c0 1.907-1.57 3.458-3.5 3.458"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-300)",
                                        d: "M4 1C2.346 1 1 2.327 1 3.958v179.084C1 184.673 2.346 186 4 186h292c1.654 0 3-1.327 3-2.958V3.958C299 2.327 297.654 1 296 1zm0-1h292c2.21 0 4 1.772 4 3.958v179.084c0 2.186-1.79 3.958-4 3.958H4c-2.21 0-4-1.772-4-3.958V3.958C0 1.772 1.79 0 4 0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M1 94h298v46H1z",
                                opacity: 0.1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M1 46h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(110 21)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Documents"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-75)",
                                stroke: "var(--anatomy-gray-600)",
                                strokeWidth: 2,
                                transform: "translate(44 16)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        stroke: "none",
                                        rx: 2
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 12,
                                        height: 12,
                                        x: 1,
                                        y: 1,
                                        fill: "none",
                                        rx: 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(64 101)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        fill: "var(--anatomy-gray-700)",
                                        rx: 2,
                                        transform: "translate(0 9)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-75)",
                                        d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 63)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 157)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M1 140h298v1H1zM1 93h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-200)",
                                        d: "M73.02 36.481a2.47 2.47 0 0 1-2.5-2.5V12.02a2.47 2.47 0 0 1 2.5-2.5h10.084a1.97 1.97 0 0 1 1.4.6l3.1 3.1a.9.9 0 0 0 .7.3h10.68a2.47 2.47 0 0 1 2.5 2.5v17.965a2.47 2.47 0 0 1-2.5 2.5Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "M99 13H88.3c-.1 0-.2 0-.4-.2l-3.1-3.1a2.41 2.41 0 0 0-1.7-.7H73a2.946 2.946 0 0 0-3 3v22a3.01 3.01 0 0 0 3 3h26a3.01 3.01 0 0 0 3-3V16a2.946 2.946 0 0 0-3-3m2 21a2.006 2.006 0 0 1-2 2H73a2.006 2.006 0 0 1-2-2V14h28a2.006 2.006 0 0 1 2 2Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(110 36)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "12 items"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-50)",
                                d: "M97.421 83.352a2.15 2.15 0 0 1-2.145-2.153V58.807a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-500)",
                                d: "m116.725 61.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 84h17.5a2.627 2.627 0 0 0 2.625-2.625V62.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75V58.625a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Onboarding"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 83)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PDF"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 130.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 108.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 131h17.5a2.627 2.627 0 0 0 2.625-2.625V109.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 115)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Budget"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 130)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "XLS"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M99.109 177.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m118.413 155.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H98.938a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 98.938 178h17.5a2.627 2.627 0 0 0 2.625-2.625V156.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H98.938a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(131.688 162)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Sales Pitch"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(131.688 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PPT"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-75)",
                                        stroke: "var(--anatomy-gray-400)",
                                        transform: "translate(265 11)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 24,
                                                height: 24,
                                                stroke: "none",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 23,
                                                height: 23,
                                                x: 0.5,
                                                y: 0.5,
                                                fill: "none",
                                                rx: 3.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-800)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M275.533 27c0-2.511 1.315-3.4 2.065-4.284a4.9 4.9 0 0 0 1.111-3.049c0-2.311-1.225-3.6-3.075-3.6s-3.111 1.339-3.111 3.6a4.94 4.94 0 0 0 1.165 3.049.64.64 0 0 1 .163.413v.922a.636.636 0 0 1-.555.642c-3.715.324-4.296 2.867-4.296 3.874 0 .111.013 1.439.021 1.548h7.487a5.44 5.44 0 0 1-.975-3.111Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M279.35 21.788a5.5 5.5 0 0 1 1.65-.255c.057 0 .113.007.17.008a5.7 5.7 0 0 0 .449-2.12c-.001-1.935-1.141-3.354-2.867-3.354-.1 0-.2.019-.3.028a4.86 4.86 0 0 1 1.325 3.572 5.9 5.9 0 0 1-.428 2.121Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281 23.044A3.956 3.956 0 1 0 284.956 27 3.956 3.956 0 0 0 281 23.044m2.222 4.178a.22.22 0 0 1-.222.222h-1.556V29a.22.22 0 0 1-.222.222h-.444a.22.22 0 0 1-.222-.222v-1.556H279a.22.22 0 0 1-.222-.222v-.444a.22.22 0 0 1 .222-.222h1.556V25a.22.22 0 0 1 .222-.222h.444a.22.22 0 0 1 .222.222v1.556H283a.22.22 0 0 1 .222.222Z"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-700)",
                                d: "M25.99 21.01a1 1 0 0 0-1.707-.71L21 23.586 17.717 20.3a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                fill: "var(--anatomy-gray-50)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M296 186.5H4c-1.93 0-3.5-1.551-3.5-3.458V3.958C.5 2.05 2.07.5 4 .5h292c1.93 0 3.5 1.551 3.5 3.458v179.084c0 1.907-1.57 3.458-3.5 3.458"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-300)",
                                        d: "M4 1C2.346 1 1 2.327 1 3.958v179.084C1 184.673 2.346 186 4 186h292c1.654 0 3-1.327 3-2.958V3.958C299 2.327 297.654 1 296 1zm0-1h292c2.21 0 4 1.772 4 3.958v179.084c0 2.186-1.79 3.958-4 3.958H4c-2.21 0-4-1.772-4-3.958V3.958C0 1.772 1.79 0 4 0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M1 94h298v46H1z",
                                opacity: 0.1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-300)",
                                d: "M1 46h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(110 21)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Documents"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(44 16)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                transform: "translate(64 101)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        width: 14,
                                        height: 14,
                                        fill: "var(--anatomy-gray-700)",
                                        rx: 2,
                                        transform: "translate(0 9)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            fill: "var(--anatomy-gray-75)",
                                            d: "M5.788 20A1 1 0 0 1 5 19.615l-2.288-3a1 1 0 1 1 1.576-1.23l1.5 1.991 3.924-4.991a1 1 0 1 1 1.576 1.23l-4.712 6a1 1 0 0 1-.788.385"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 63)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                    fill: "var(--anatomy-gray-75)",
                                    stroke: "var(--anatomy-gray-600)",
                                    strokeWidth: 2,
                                    transform: "translate(64 157)",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 14,
                                            height: 14,
                                            stroke: "none",
                                            rx: 2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            width: 12,
                                            height: 12,
                                            x: 1,
                                            y: 1,
                                            fill: "none",
                                            rx: 1
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-600)",
                                d: "M1 140h298v1H1zM1 93h298v1H1z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-200)",
                                        d: "M73.02 36.481a2.47 2.47 0 0 1-2.5-2.5V12.02a2.47 2.47 0 0 1 2.5-2.5h10.084a1.97 1.97 0 0 1 1.4.6l3.1 3.1a.9.9 0 0 0 .7.3h10.68a2.47 2.47 0 0 1 2.5 2.5v17.965a2.47 2.47 0 0 1-2.5 2.5Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "M99 13H88.3c-.1 0-.2 0-.4-.2l-3.1-3.1a2.41 2.41 0 0 0-1.7-.7H73a2.946 2.946 0 0 0-3 3v22a3.01 3.01 0 0 0 3 3h26a3.01 3.01 0 0 0 3-3V16a2.946 2.946 0 0 0-3-3m2 21a2.006 2.006 0 0 1-2 2H73a2.006 2.006 0 0 1-2-2V14h28a2.006 2.006 0 0 1 2 2Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(110 36)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "12 items"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 83.352a2.15 2.15 0 0 1-2.145-2.153V58.807a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 61.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 84h17.5a2.627 2.627 0 0 0 2.625-2.625V62.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75V58.625a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 68)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Onboarding"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 83)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PDF"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M97.421 130.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m116.725 108.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H97.25a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 97.25 131h17.5a2.627 2.627 0 0 0 2.625-2.625V109.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H97.25a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(130 115)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Budget"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(130 130)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "XLS"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-50)",
                                        d: "M99.109 177.352a2.15 2.15 0 0 1-2.145-2.153v-22.392a2.15 2.15 0 0 1 2.145-2.155h13.194a1.7 1.7 0 0 1 1.211.5l4.392 4.4a1.74 1.74 0 0 1 .505 1.22v18.427a2.15 2.15 0 0 1-2.147 2.153Z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        fill: "var(--anatomy-gray-500)",
                                        d: "m118.413 155.1-4.478-4.461a2.16 2.16 0 0 0-1.54-.639H98.938a2.633 2.633 0 0 0-2.625 2.625v22.75A2.627 2.627 0 0 0 98.938 178h17.5a2.627 2.627 0 0 0 2.625-2.625V156.65a2.2 2.2 0 0 0-.65-1.55m-5.04-3.789 4.392 4.375h-3.952a.44.44 0 0 1-.437-.437Zm4.812 24.062a1.75 1.75 0 0 1-1.75 1.75H98.938a1.75 1.75 0 0 1-1.75-1.75v-22.748a1.755 1.755 0 0 1 1.75-1.75h13.457a.4.4 0 0 1 .1.009v4.366a1.316 1.316 0 0 0 1.318 1.312h4.366a.3.3 0 0 1 .009.088Z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 14,
                                transform: "translate(131.688 162)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "Sales Pitch"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                fill: "var(--anatomy-gray-800)",
                                fontFamily: "var(--anatomy-font)",
                                fontSize: 12,
                                transform: "translate(131.688 177)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 0,
                                    y: 0,
                                    children: "PPT"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-75)",
                                        stroke: "var(--anatomy-gray-400)",
                                        transform: "translate(265 11)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 24,
                                                height: 24,
                                                stroke: "none",
                                                rx: 4
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                width: 23,
                                                height: 23,
                                                x: 0.5,
                                                y: 0.5,
                                                fill: "none",
                                                rx: 3.5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                        fill: "var(--anatomy-gray-800)",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M275.533 27c0-2.511 1.315-3.4 2.065-4.284a4.9 4.9 0 0 0 1.111-3.049c0-2.311-1.225-3.6-3.075-3.6s-3.111 1.339-3.111 3.6a4.94 4.94 0 0 0 1.165 3.049.64.64 0 0 1 .163.413v.922a.636.636 0 0 1-.555.642c-3.715.324-4.296 2.867-4.296 3.874 0 .111.013 1.439.021 1.548h7.487a5.44 5.44 0 0 1-.975-3.111Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M279.35 21.788a5.5 5.5 0 0 1 1.65-.255c.057 0 .113.007.17.008a5.7 5.7 0 0 0 .449-2.12c-.001-1.935-1.141-3.354-2.867-3.354-.1 0-.2.019-.3.028a4.86 4.86 0 0 1 1.325 3.572 5.9 5.9 0 0 1-.428 2.121Z"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M281 23.044A3.956 3.956 0 1 0 284.956 27 3.956 3.956 0 0 0 281 23.044m2.222 4.178a.22.22 0 0 1-.222.222h-1.556V29a.22.22 0 0 1-.222.222h-.444a.22.22 0 0 1-.222-.222v-1.556H279a.22.22 0 0 1-.222-.222v-.444a.22.22 0 0 1 .222-.222h1.556V25a.22.22 0 0 1 .222-.222h.444a.22.22 0 0 1 .222.222v1.556H283a.22.22 0 0 1 .222.222Z"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "var(--anatomy-gray-700)",
                                    d: "M25.99 21.01a1 1 0 0 0-1.707-.71L21 23.586 17.717 20.3a1.002 1.002 0 1 0-1.417 1.417l3.993 3.983a1 1 0 0 0 1.414 0l3.993-3.983a1 1 0 0 0 .29-.707"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgTree;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"atBPa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocusRing = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 40,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 40px)/2) 10px"
        },
        viewBox: "0 0 80 40",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(4 4)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 72,
                    height: 32,
                    fill: "var(--anatomy-gray-900)",
                    rx: 16
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "rgba(0,0,0,0)",
                    stroke: "var(--anatomy-gray-600)",
                    strokeWidth: 2,
                    transform: "translate(-4 -4)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 80,
                            height: 40,
                            stroke: "none",
                            rx: 20
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 78,
                            height: 38,
                            x: 1,
                            y: 1,
                            fill: "none",
                            rx: 19
                        })
                    ]
                })
            ]
        })
    });
exports.default = SvgUseFocusRing;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bKLu9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 30,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 30px)/2) 10px"
        },
        viewBox: "0 0 200 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-600)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 200,
                        height: 30,
                        stroke: "none",
                        rx: 5
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 198,
                        height: 28,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                fill: "var(--anatomy-gray-900)",
                fontFamily: "var(--anatomy-font)",
                fontSize: 10,
                transform: "translate(11 20)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                    x: 0,
                    y: 0
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--anatomy-gray-900)",
                d: "M11 5h1v19h-1z"
            })
        ]
    });
exports.default = SvgUseFocus;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6rzJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseFocusWithin = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 108,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 108px)/2) 10px"
        },
        viewBox: "0 0 231 108",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "useFocusWithin_svg__a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h136v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "useFocusWithin_svg__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "none",
                            d: "M0 0h207v20H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-600)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 231,
                        height: 50,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 229,
                        height: 48,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-50)",
                        stroke: "var(--anatomy-gray-600)",
                        transform: "translate(12 10)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 63,
                                height: 30,
                                stroke: "none",
                                rx: 5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: 62,
                                height: 29,
                                x: 0.5,
                                y: 0.5,
                                fill: "none",
                                rx: 4.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        fill: "var(--anatomy-gray-900)",
                        fontFamily: "var(--anatomy-font)",
                        fontSize: 10,
                        transform: "translate(23 30)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 0
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M23 15h1v19h-1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#useFocusWithin_svg__a)",
                transform: "translate(83 15)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(71)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-300)",
                transform: "translate(0 58)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 231,
                        height: 50,
                        stroke: "none",
                        rx: 6
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 230,
                        height: 49,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 5.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#useFocusWithin_svg__b)",
                transform: "translate(12 73)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(71)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 63,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 4,
                        transform: "translate(142)"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseFocusWithin;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fdavU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseHover = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 43.5,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 43.5px)/2) 10px"
        },
        viewBox: "0 0 72 43.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-300)",
                stroke: "var(--anatomy-gray-400)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M53.214 17.635v24.032a.366.366 0 0 0 .626.259l6.7-6.7h9.374a.366.366 0 0 0 .259-.626Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "M71.164 33.511 54.249 16.598a1.47 1.47 0 0 0-1.035-.429h-.365a1.1 1.1 0 0 0-1.1 1.1v24.286a1.91 1.91 0 0 0 1.6 1.93 1.82 1.82 0 0 0 1.526-.523l6.274-6.274h8.768a1.83 1.83 0 0 0 1.817-1.58 1.9 1.9 0 0 0-.57-1.597m-1.246 1.712h-9.375l-6.7 6.7a.36.36 0 0 1-.256.108.366.366 0 0 1-.369-.367V17.635l16.959 16.962a.366.366 0 0 1-.259.626",
                        opacity: 0.65
                    })
                ]
            })
        ]
    });
exports.default = SvgUseHover;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d2wmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseKeyboard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        height: 81,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 81px)/2) 10px"
        },
        viewBox: "0 0 191 81",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-1747 -1604)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 190,
                    height: 80,
                    fill: "var(--anatomy-gray-200)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 4,
                    transform: "translate(1747.5 1604.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1606.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1768.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1781.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1794.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1807.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1820.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1833.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1846.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1859.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1872.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1885.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1898.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1911.5 1606.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1924.5 1606.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 20.5,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1645.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 27,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1658.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 13,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1769.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1784.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 76,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1804.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 13,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1902.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1917.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 18,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1882.5 1671.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1749.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1762.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1775.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1788.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1801.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1814.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1827.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1840.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1853.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1866.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1879.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1892.5 1619.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1905.5 1619.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1918.5 1619.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 17,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1749.5 1632.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1768.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1781.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1794.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1807.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1820.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1833.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1846.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1859.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1872.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1885.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1898.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1911.5 1632.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1924.5 1632.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1772 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1785 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1798 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1811 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1824 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1837 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1850 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1863 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1876 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1889 1645.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1902 1645.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 20.5,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1915 1645.5)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1778.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1791.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1804.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1817.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1830.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1843.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1856.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1869.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1882.5 1658.5)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 11,
                            height: 11,
                            fill: "var(--anatomy-gray-75)",
                            stroke: "var(--anatomy-gray-600)",
                            rx: 2,
                            transform: "translate(1895.5 1658.5)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    width: 27,
                    height: 11,
                    fill: "var(--anatomy-gray-75)",
                    stroke: "var(--anatomy-gray-600)",
                    rx: 2,
                    transform: "translate(1908.5 1658.5)"
                })
            ]
        })
    });
exports.default = SvgUseKeyboard;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6sD3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseLongPress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 89.088,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 89px)/2) 10px"
        },
        viewBox: "-17 0 106.868 89.088",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-500)",
                strokeWidth: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-900)",
                                d: "M54.261 39.495c-1.569-2.528-9.981-10.294-11.747-13.412-1.572-3.115.758-5.854 2.322-4.882 1.37 1.163 6.063 5.046 10.755 8.735a79 79 0 0 1 3.91 3.745 95 95 0 0 1 9.246 12.22.416.416 0 0 0 .706-.439 98 98 0 0 0-8.821-11.768 7.6 7.6 0 0 1 5.5-.864 3.95 3.95 0 0 1 2.061 1.309 50.7 50.7 0 0 1 7.553 10.708.416.416 0 0 0 .744-.372 52 52 0 0 0-7.324-10.516 4.17 4.17 0 0 1 4.178-.774 9.54 9.54 0 0 1 3.4 2.848 59.6 59.6 0 0 1 5.417 7.649.416.416 0 1 0 .736-.389 53 53 0 0 0-4.591-6.619 4.62 4.62 0 0 1 3.826-.6c3.171 1.757 4.591 2.625 6.851 5.761a37.8 37.8 0 0 1 4.8 9.139c2.92 7.977 6.091 17.177 13.069 24.95 0 0 .271 1.429-1.308 4.068-2.281 3.809-10.883 10.279-16.596 8.909l-5.282-5.245a8.15 8.15 0 0 0-3.517-2.132 120 120 0 0 1-14.26-6.97c-5.86-3.1-14.678-15.35-16.249-18.271s-5.307-11.482-4.92-12.464 2.923-.986 4.875-.017 4.068 6 6.275 8.888c.926 1.212 5.027 3.931 6.284 4.8a34.6 34.6 0 0 0-2.593-8.456 51 51 0 0 0-5.3-9.535"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "var(--anatomy-gray-700)",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "m59.422 23.362-5.245.629a.42.42 0 0 1-.452-.38l-.148-1.236a.417.417 0 0 1 .35-.474l5.247-.628a.42.42 0 0 1 .452.379l.148 1.236a.417.417 0 0 1-.352.474m-23.208 3.535-5.244.628a.417.417 0 0 1-.453-.378l-.148-1.237a.417.417 0 0 1 .35-.474l5.246-.631a.417.417 0 0 1 .452.378l.148 1.236a.417.417 0 0 1-.35.478m20.322-11.73-3.875 3.589a.42.42 0 0 1-.588-.04l-.848-.911a.417.417 0 0 1 .003-.59l3.879-3.594a.42.42 0 0 1 .588.04l.847.914a.417.417 0 0 1-.006.593M39.452 31.504l-3.875 3.59a.42.42 0 0 1-.588-.04l-.846-.913a.417.417 0 0 1 .002-.59l3.875-3.591a.42.42 0 0 1 .588.04l.847.914a.416.416 0 0 1-.003.589Zm9.506-21.052-1.024 5.181a.417.417 0 0 1-.5.314l-1.221-.241a.42.42 0 0 1-.34-.478l1.02-5.185a.417.417 0 0 1 .5-.314l1.222.241a.42.42 0 0 1 .34.48Zm-4.213 23.202-1.023 5.184a.42.42 0 0 1-.5.314l-1.221-.242a.416.416 0 0 1-.34-.477l1.023-5.182a.417.417 0 0 1 .5-.314l1.22.234a.42.42 0 0 1 .34.479Zm-5.008-22.682 2.218 4.795a.42.42 0 0 1-.22.548l-1.13.522a.42.42 0 0 1-.56-.185l-2.216-4.8a.42.42 0 0 1 .22-.548l1.13-.523a.42.42 0 0 1 .56.187Zm-6.445 5.834 4.613 2.576a.417.417 0 0 1 .144.571l-.608 1.087a.416.416 0 0 1-.561.178l-4.612-2.575a.417.417 0 0 1-.148-.572l.609-1.086a.416.416 0 0 1 .561-.178Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "var(--anatomy-gray-50)",
                                fillOpacity: 0.6,
                                d: "M59.746 23.113a.4.4 0 0 0 .028-.225l-.148-1.236a.42.42 0 0 0-.453-.38l-5.245.628a.417.417 0 0 0-.35.475l.148 1.237c.02.23.223.399.452.379l5.246-.629a.42.42 0 0 0 .322-.25m-3.118-8.08a.42.42 0 0 0-.087-.457l-.847-.914a.42.42 0 0 0-.588-.04l-3.877 3.59a.417.417 0 0 0-.003.59l.847.915c.152.173.415.19.589.04l3.875-3.59q.06-.061.091-.134m-12.93 23.874a.4.4 0 0 0 .023-.07l1.024-5.182a.42.42 0 0 0-.343-.48l-1.222-.241a.417.417 0 0 0-.5.313l-1.024 5.184a.416.416 0 0 0 .344.478l1.221.242c.2.046.4-.06.477-.244m4.213-23.203a.4.4 0 0 0 .022-.07l1.024-5.183a.42.42 0 0 0-.342-.48l-1.222-.242a.417.417 0 0 0-.5.314l-1.025 5.183a.42.42 0 0 0 .344.48l1.221.24c.2.047.4-.06.478-.242m-8.366 15.666a.42.42 0 0 0-.087-.456l-.847-.914a.42.42 0 0 0-.588-.04l-3.879 3.594a.417.417 0 0 0-.002.59l.845.914c.152.173.415.191.589.04l3.88-3.595q.059-.06.09-.133m2.41-15.28a.42.42 0 0 0 0-.327l-2.217-4.795a.42.42 0 0 0-.56-.187l-1.13.523a.42.42 0 0 0-.22.548l2.217 4.795a.42.42 0 0 0 .56.186l1.13-.522a.42.42 0 0 0 .22-.22m-5.42 10.556a.4.4 0 0 0 .029-.224l-.148-1.237a.417.417 0 0 0-.453-.378l-5.245.627a.417.417 0 0 0-.35.475l.147 1.237c.021.229.224.398.453.378l5.245-.628a.42.42 0 0 0 .322-.25m1.536-6.746a.42.42 0 0 0-.169-.52l-4.614-2.577a.416.416 0 0 0-.561.179l-.61 1.088a.417.417 0 0 0 .147.571l4.613 2.576a.416.416 0 0 0 .561-.178l.607-1.087a.4.4 0 0 0 .026-.052m22.595 3.604a1.41 1.41 0 0 1-1.124.852l-5.246.628-.033.004c-.77.066-1.454-.501-1.533-1.268l-.145-1.215a1.417 1.417 0 0 1 1.223-1.598l5.245-.628.033-.003c.77-.066 1.454.5 1.533 1.267l.146 1.215c.035.253 0 .51-.1.746m-3.118-8.081a1.4 1.4 0 0 1-.332.476l-3.875 3.59-.025.023c-.583.506-1.47.45-1.984-.123l-.833-.899a1.413 1.413 0 0 1 .025-1.99l.007-.006.021-.02 3.873-3.587.024-.022a1.42 1.42 0 0 1 1.985.123l.833.9c.393.41.504 1.01.281 1.535m-12.93 23.874a1.42 1.42 0 0 1-1.602.833l-1.2-.238a1.42 1.42 0 0 1-1.142-1.658l1.024-5.182.006-.029q.029-.122.077-.238a1.416 1.416 0 0 1 1.604-.832l1.2.237a1.42 1.42 0 0 1 1.14 1.658l-1.023 5.183-.007.031q-.029.121-.077.235m4.213-23.203a1.416 1.416 0 0 1-1.604.831l-1.2-.237a1.42 1.42 0 0 1-1.141-1.657l1.024-5.183.006-.03q.03-.12.078-.238a1.416 1.416 0 0 1 1.604-.831l1.2.237a1.42 1.42 0 0 1 1.14 1.658l-1.024 5.182-.006.03a1.4 1.4 0 0 1-.077.238M40.466 31.76a1.4 1.4 0 0 1-.307.452l-.004.005-.005.004-.02.019-3.874 3.591-.024.022c-.584.506-1.47.45-1.985-.123l-.832-.898a1.413 1.413 0 0 1 .03-1.994l.003-.003.02-.02 3.875-3.59.024-.022a1.42 1.42 0 0 1 1.985.123l.832.898c.394.41.505 1.01.282 1.536m2.411-15.28c-.14.333-.4.596-.73.742l-1.112.514a1.424 1.424 0 0 1-1.897-.67l-2.218-4.795-.012-.028a1.43 1.43 0 0 1 0-1.11c.14-.332.4-.595.729-.742l1.113-.515a1.42 1.42 0 0 1 1.897.671l2.217 4.795.013.028c.15.353.15.757 0 1.11m-5.42 10.557a1.41 1.41 0 0 1-1.124.853l-5.245.627-.03.003a1.42 1.42 0 0 1-1.536-1.266l-.146-1.215A1.416 1.416 0 0 1 30.6 24.44l5.245-.628.03-.003a1.42 1.42 0 0 1 1.537 1.267l.145 1.215c.034.253 0 .51-.1.745m1.536-6.746q-.034.08-.078.157l-.597 1.069a1.42 1.42 0 0 1-1.9.59l-.005-.004-.024-.013-4.612-2.575-.02-.012a1.42 1.42 0 0 1-.507-1.933l.6-1.067a1.42 1.42 0 0 1 1.899-.588l.005.003.024.013 4.613 2.575.028.016c.602.363.849 1.123.574 1.769"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.072 48.072a8 8 0 1 0 8 8 8 8 0 0 0-8-8m0 15a7 7 0 1 1 7-7 7 7 0 0 1-7 7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M27.072 55.115v-4.543a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v5.293a.5.5 0 0 0 .146.353l2.8 2.8a.5.5 0 0 0 .707 0l.668-.668a.5.5 0 0 0 0-.707l-2.175-2.171a.5.5 0 0 1-.146-.357"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseLongPress;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ZHMO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUseMove = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 57,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 57px)/2) 10px"
        },
        viewBox: "0 0 57 57",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-300)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 28.5,
                        cy: 28.5,
                        r: 28.5,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 28.5,
                        cy: 28.5,
                        r: 28,
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        d: "m38.748 26.588 4.028 4.531a.317.317 0 0 1-.224.541h-2.536v5.072h5.072v-2.536a.317.317 0 0 1 .319-.318.3.3 0 0 1 .222.093l4.531 4.028-4.531 4.028a.3.3 0 0 1-.222.093.317.317 0 0 1-.319-.318v-2.534h-5.072v5.072h2.537a.317.317 0 0 1 .224.541l-4.028 4.531-4.028-4.531a.317.317 0 0 1 .224-.541h2.536v-5.072h-5.073v2.537a.317.317 0 0 1-.319.318.3.3 0 0 1-.222-.093L27.336 38l4.531-4.028a.3.3 0 0 1 .222-.093.317.317 0 0 1 .319.318v2.536h5.072V31.66h-2.536a.317.317 0 0 1-.224-.541Zm.474-1.375a.634.634 0 0 0-.948 0l-4.486 5.046a1.586 1.586 0 0 0-.1 2.054 1.63 1.63 0 0 0 1.312.615h1.212v2.536h-2.536v-1.177a1.65 1.65 0 0 0-1.359-1.661 1.58 1.58 0 0 0-1.31.414l-5.046 4.486a.634.634 0 0 0 0 .948l5.046 4.486a1.58 1.58 0 0 0 1.31.414 1.65 1.65 0 0 0 1.359-1.66v-1.178h2.536v2.536H35a1.63 1.63 0 0 0-1.312.615 1.586 1.586 0 0 0 .1 2.054l4.486 5.046a.634.634 0 0 0 .948 0l4.486-5.046a1.586 1.586 0 0 0 .1-2.054 1.63 1.63 0 0 0-1.312-.615h-1.212v-2.536h2.536v1.177a1.65 1.65 0 0 0 1.359 1.66 1.58 1.58 0 0 0 1.31-.414l5.046-4.486a.634.634 0 0 0 0-.948l-5.046-4.485a1.585 1.585 0 0 0-2.669 1.156v1.268h-2.536v-2.536h1.212a1.63 1.63 0 0 0 1.312-.615 1.586 1.586 0 0 0-.1-2.054Z",
                        opacity: 0.65
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M40.016 31.66h2.536a.317.317 0 0 0 .224-.541l-4.028-4.531-4.028 4.531a.317.317 0 0 0 .224.541h2.536v5.072h-5.072v-2.536a.317.317 0 0 0-.541-.224L27.336 38l4.531 4.028a.317.317 0 0 0 .541-.224v-2.536h5.072v5.072h-2.536a.317.317 0 0 0-.224.541l4.028 4.531 4.028-4.531a.317.317 0 0 0-.224-.541h-2.536v-5.072h5.072v2.536a.317.317 0 0 0 .541.224L50.16 38l-4.531-4.028a.317.317 0 0 0-.541.224v2.536h-5.072Z"
                    })
                ]
            })
        ]
    });
exports.default = SvgUseMove;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9O6bO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUsePress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 89.088,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "calc((152px - 89px)/2) 10px"
        },
        viewBox: "17 0 105.856 89.088",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-400)",
                stroke: "var(--anatomy-gray-500)",
                strokeWidth: 2,
                transform: "translate(33.856)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 72,
                        height: 32,
                        stroke: "none",
                        rx: 16
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 30,
                        x: 1,
                        y: 1,
                        fill: "none",
                        rx: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-900)",
                        d: "M52.607 39.494c1.569-2.528 9.981-10.294 11.747-13.412 1.571-3.115-.758-5.854-2.322-4.882-1.368 1.163-6.063 5.046-10.755 8.735a79 79 0 0 0-3.91 3.745 95 95 0 0 0-9.246 12.22.416.416 0 0 1-.706-.439 98 98 0 0 1 8.821-11.768 7.6 7.6 0 0 0-5.5-.864 3.95 3.95 0 0 0-2.061 1.309 50.7 50.7 0 0 0-7.551 10.703.416.416 0 0 1-.744-.372 52 52 0 0 1 7.322-10.511 4.17 4.17 0 0 0-4.178-.774 9.54 9.54 0 0 0-3.4 2.848 59.6 59.6 0 0 0-5.417 7.649.416.416 0 1 1-.736-.389 53 53 0 0 1 4.591-6.621 4.62 4.62 0 0 0-3.826-.6c-3.171 1.757-4.591 2.625-6.851 5.761a37.8 37.8 0 0 0-4.8 9.139c-2.92 7.977-6.091 17.177-13.069 24.95 0 0-.271 1.429 1.308 4.068C3.605 83.8 12.207 90.27 17.92 88.9l5.282-5.245a8.15 8.15 0 0 1 3.517-2.132 120 120 0 0 0 14.26-6.97c5.86-3.1 14.678-15.35 16.249-18.271s5.307-11.486 4.92-12.463-2.923-.986-4.875-.017-4.068 6-6.275 8.888c-.926 1.212-5.027 3.931-6.284 4.8a34.6 34.6 0 0 1 2.593-8.456 51 51 0 0 1 5.3-9.535"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-700)",
                strokeLinejoin: "round",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m47.432 23.37 5.246.63a.42.42 0 0 0 .452-.38l.148-1.236a.417.417 0 0 0-.35-.475l-5.245-.627a.42.42 0 0 0-.453.379l-.148 1.235a.417.417 0 0 0 .35.474m23.209 3.534 5.245.628a.417.417 0 0 0 .452-.378l.148-1.237a.417.417 0 0 0-.35-.474l-5.245-.628a.417.417 0 0 0-.453.378l-.147 1.237a.417.417 0 0 0 .35.474m-20.322-11.73 3.874 3.59a.42.42 0 0 0 .589-.04l.847-.914a.417.417 0 0 0-.003-.59L51.75 13.63a.42.42 0 0 0-.588.04l-.847.914a.417.417 0 0 0 .004.59ZM67.4 31.515l3.874 3.59a.42.42 0 0 0 .589-.04l.846-.913a.417.417 0 0 0-.003-.59l-3.873-3.593a.42.42 0 0 0-.589.04l-.847.914a.416.416 0 0 0 .004.589Zm-9.507-21.057 1.028 5.181a.417.417 0 0 0 .5.314l1.221-.24a.42.42 0 0 0 .34-.48l-1.02-5.184a.417.417 0 0 0-.5-.314l-1.222.241a.42.42 0 0 0-.34.48Zm4.216 23.202 1.025 5.183a.42.42 0 0 0 .5.314l1.22-.242a.416.416 0 0 0 .341-.477l-1.022-5.186a.417.417 0 0 0-.5-.314l-1.219.242a.42.42 0 0 0-.34.478Zm5.007-22.685-2.218 4.794a.42.42 0 0 0 .22.549l1.13.522a.42.42 0 0 0 .56-.186l2.218-4.796a.42.42 0 0 0-.22-.548l-1.131-.524a.42.42 0 0 0-.56.187Zm6.448 5.836-4.613 2.576a.417.417 0 0 0-.143.572l.607 1.086a.416.416 0 0 0 .56.178l4.615-2.575a.417.417 0 0 0 .149-.571l-.612-1.088a.416.416 0 0 0-.562-.178Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "var(--anatomy-gray-50)",
                        fillOpacity: 0.6,
                        d: "M47.11 23.12c.054.13.173.228.322.25l5.245.629c.23.02.432-.15.453-.38l.148-1.236a.417.417 0 0 0-.35-.475l-5.246-.627a.42.42 0 0 0-.452.379l-.149 1.236a.4.4 0 0 0 .029.224m3.117-8.08q.031.073.091.133l3.876 3.59c.174.152.437.134.588-.04l.847-.913a.417.417 0 0 0-.003-.59l-.004-.004-3.873-3.587a.42.42 0 0 0-.588.04l-.847.914a.42.42 0 0 0-.087.456m12.93 23.875c.078.183.277.29.477.244l1.222-.242a.416.416 0 0 0 .343-.478v-.002l-1.024-5.182a.417.417 0 0 0-.5-.314l-1.222.242a.42.42 0 0 0-.343.48l1.024 5.183a.4.4 0 0 0 .023.07M58.945 15.71a.42.42 0 0 0 .477.243l1.222-.242a.42.42 0 0 0 .343-.48l-1.024-5.182a.417.417 0 0 0-.5-.314l-1.222.241a.42.42 0 0 0-.343.481l1.024 5.182a.4.4 0 0 0 .023.07m8.365 15.667q.03.072.09.133l.005.004 3.875 3.591c.173.151.436.133.588-.04l.846-.914a.417.417 0 0 0-.003-.59l-.004-.003-3.874-3.591a.42.42 0 0 0-.589.04l-.846.914a.42.42 0 0 0-.088.456m-2.41-15.28c.04.096.116.177.219.22l1.13.523a.42.42 0 0 0 .56-.186l2.218-4.795a.42.42 0 0 0-.22-.548l-1.13-.523a.42.42 0 0 0-.56.187l-2.218 4.795a.42.42 0 0 0 0 .327m5.42 10.557c.055.13.173.228.322.25l5.245.628c.23.02.432-.149.453-.378l.148-1.237a.417.417 0 0 0-.35-.475l-5.246-.627a.417.417 0 0 0-.452.378l-.148 1.237a.4.4 0 0 0 .028.224m-1.536-6.746.026.051.607 1.088a.416.416 0 0 0 .561.178h.002l4.612-2.576a.417.417 0 0 0 .147-.571v-.002l-.61-1.086a.416.416 0 0 0-.561-.179l-.002.001-4.613 2.576a.42.42 0 0 0-.169.52M46.19 23.51a1.4 1.4 0 0 1-.1-.745l.146-1.215a1.42 1.42 0 0 1 1.566-1.264l5.245.628.03.004a1.417 1.417 0 0 1 1.194 1.594l-.145 1.215a1.42 1.42 0 0 1-1.567 1.264l-5.245-.628-.03-.004a1.41 1.41 0 0 1-1.094-.849m3.117-8.08a1.41 1.41 0 0 1 .282-1.536l.833-.9a1.42 1.42 0 0 1 2.008-.1l3.873 3.587.021.02.004.004a1.416 1.416 0 0 1 .028 1.992l-.832.899a1.42 1.42 0 0 1-2.01.1l-3.875-3.59-.023-.022a1.4 1.4 0 0 1-.309-.455m12.93 23.874a1.4 1.4 0 0 1-.083-.266l-1.024-5.184-.006-.032a1.42 1.42 0 0 1 1.146-1.625l1.2-.237a1.416 1.416 0 0 1 1.688 1.1l1.024 5.181.006.033a1.42 1.42 0 0 1-1.148 1.625l-1.2.238a1.42 1.42 0 0 1-1.603-.833m-4.212-23.203a1.4 1.4 0 0 1-.084-.268l-1.024-5.182-.005-.03a1.42 1.42 0 0 1 1.146-1.628l1.2-.237a1.416 1.416 0 0 1 1.687 1.099l1.024 5.183q.005.016.006.033a1.42 1.42 0 0 1-1.146 1.624l-1.2.237a1.416 1.416 0 0 1-1.604-.831m8.365 15.666a1.41 1.41 0 0 1 .283-1.536l.832-.899a1.42 1.42 0 0 1 2.009-.1l3.874 3.59.02.02.004.003.004.004q.199.196.307.454a1.41 1.41 0 0 1-.282 1.536l-.832.898a1.42 1.42 0 0 1-2.009.101l-3.874-3.591-.02-.019-.005-.004-.004-.005a1.4 1.4 0 0 1-.307-.452m-2.41-15.28a1.43 1.43 0 0 1 .012-1.138l2.217-4.795.014-.029a1.42 1.42 0 0 1 1.884-.642l1.112.515c.33.147.589.41.73.742a1.43 1.43 0 0 1-.013 1.138l-2.217 4.795-.016.032a1.424 1.424 0 0 1-1.881.638l-1.113-.514a1.4 1.4 0 0 1-.73-.742m5.419 10.557a1.4 1.4 0 0 1-.1-.745l.146-1.216a1.42 1.42 0 0 1 1.566-1.263l5.245.628.03.004a1.417 1.417 0 0 1 1.194 1.594l-.145 1.215a1.42 1.42 0 0 1-1.567 1.263l-5.245-.627-.03-.004a1.41 1.41 0 0 1-1.094-.849M67.862 20.3a1.426 1.426 0 0 1 .603-1.785l4.612-2.576.024-.013.006-.002a1.42 1.42 0 0 1 1.9.588l.598 1.067q.044.077.08.158a1.42 1.42 0 0 1-.606 1.787l-4.613 2.575-.023.013-.006.003a1.42 1.42 0 0 1-1.9-.59l-.597-1.068a1.4 1.4 0 0 1-.078-.157"
                    })
                ]
            })
        ]
    });
exports.default = SvgUsePress;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hPZ8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgVirtualizer = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 160,
        style: {
            background: "var(--anatomy-gray-100)",
            padding: "40px 10px"
        },
        viewBox: "0 0 200 160",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--anatomy-gray-50)",
                stroke: "var(--anatomy-gray-400)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 200,
                        height: 160,
                        stroke: "none",
                        rx: 4
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 199,
                        height: 159,
                        x: 0.5,
                        y: 0.5,
                        fill: "none",
                        rx: 3.5
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(8 8)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 80,
                        height: 8,
                        x: 8,
                        y: 10,
                        fill: "var(--anatomy-gray-600)",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(8 40)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 100,
                        height: 8,
                        x: 8,
                        y: 10,
                        fill: "var(--anatomy-gray-600)",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(8 72)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 90,
                        height: 8,
                        x: 8,
                        y: 10,
                        fill: "var(--anatomy-gray-600)",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(8 104)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 28,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 110,
                        height: 8,
                        x: 8,
                        y: 10,
                        fill: "var(--anatomy-gray-600)",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                opacity: 0.5,
                transform: "translate(8 136)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 176,
                        height: 20,
                        fill: "var(--anatomy-gray-200)",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 70,
                        height: 8,
                        x: 8,
                        y: 6,
                        fill: "var(--anatomy-gray-600)",
                        rx: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 4,
                height: 144,
                x: 188,
                y: 8,
                fill: "var(--anatomy-gray-200)",
                rx: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 4,
                height: 40,
                x: 188,
                y: 8,
                fill: "var(--anatomy-gray-600)",
                rx: 2
            })
        ]
    });
exports.default = SvgVirtualizer;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"54QRr":[function() {},{}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/4b95750675aea7e2e6de816c40598baaf11b1b4e/s2-docs/")

//# sourceMappingURL=s2.4765dc43.js.map
